<template>
  <v-container>
    <v-app-bar color="primary" app fixed>
      <v-icon @click="back" color="white">mdi-arrow-left</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title style="color:white; margin-right:20px;">{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items v-if="order.code && editEnable">
        <v-btn
          icon
          dark
          @click="updateOrder"
        >
          <v-icon>mdi-content-save</v-icon>
        </v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <div style="margin-top:65px">
      <div v-if="value == 0" class="bottomNavigation0">
        <h2 v-if="order.code > 0" style="color:rgb(124,131,124); margin-top: -5px; margin-bottom: 10px;">{{labelOrder}} Nº: {{order.code}}</h2>

        <simple-select 
          :model="order.listStatusSelected"
          label="Status"
          :items="listStatus.items"
          v-on:valueChanged="changeStatus"
          :disabled="disabledOrder"
        ></simple-select>
        
        <h2 style="color:rgb(124,131,124); margin-top: -15px;">Cliente</h2>
        <span v-if="order.clientSelected == null && orderId != null && orderId != 0">Obtendo dados do cliente. Por favor, aguarde...</span>
        <span v-if="order.clientSelected != null">{{order.clientSelected.subtitles[0].value}}</span>
        <b><p v-if="!(order.clientSelected == null && orderId != null && orderId != 0) && !disabledOrder" @click="openListClients" :style="`color:${$vuetify.theme.defaults.light.primary}`">{{order.clientSelected != null && order.clientSelected.subtitles[1].value != "Selecione o Cliente" ? "Trocar" : "Selecione"}} o cliente</p></b>

        <v-text-field
          v-model="emailClient"
          label="Email"
          outlined
          clearable
          style="border-radius:12px"
          :disabled="true"
          filled
        ></v-text-field>

        <v-text-field
          v-model="phoneClient"
          label="Fone Cliente"
          outlined
          clearable
          style="border-radius:12px"
          :disabled="true"
          filled
        ></v-text-field>

        <v-text-field
          v-model="celClient"
          label="Cel Cliente"
          outlined
          clearable
          style="border-radius:12px"
          :disabled="true"
          filled
        ></v-text-field>

        <v-textarea
          v-model="addressClient"
          label="Endereço Cliente"
          auto-grow
          outlined
          rows="2"
          row-height="20"
          style="border-radius:12px"
          :disabled="true"
          filled
        ></v-textarea>

        <simple-select 
          :model="order.sectorSelected"
          :label=labelDepartment
          :items="listSector.items"
          v-on:valueChanged="changeSector"
          :disabled="disabledOrder"
        ></simple-select>

        <v-dialog
          ref="dialogInitial"
          v-model="createDate.show"
          :return-value.sync="order.createDate"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formatDateInitial"
              label="Emissão"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              style="border-radius:12px"
              :disabled="disabledOrder"
            ></v-text-field>
          </template>
            <v-date-picker
              locale="pt-br"
              v-model="order.createDate"
              scrollable
            >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="order.createDate = ''; $refs.dialogInitial.save(order.createDate); createDate.show = false"
                >
                  Limpar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="createDate.show = false"
                >
                  Voltar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogInitial.save(order.createDate)"
                >
                  Ok
                </v-btn>
            </v-date-picker>
        </v-dialog>

        <h2 style="color:rgb(124,131,124); margin-top: -15px;">Fornecedor</h2>
        <span v-if="order.providerSelected != null">{{order.providerSelected.subtitles[0].value}}</span>
        <b v-if="!disabledOrder"><p v-if="!disabledOrder" @click="sheetProvider = true" :style="`color:${$vuetify.theme.defaults.light.primary}`">{{order.providerSelected != null && order.providerSelected.subtitles[1].value != "Selecione o Fornecedor" ? "Trocar" : "Selecione"}} o fornecedor</p></b>

        <v-row style="margin-top: 0px">
          <div class="files"> 
            <div v-for="(file, index) in order.files" :key="index">
              <v-icon v-if="canRemoveAttachment && !disabledOrder" style="margin-bottom: -50px; z-index: 1;" @click="removeAttachment(index)">
                mdi-close-circle-outline
              </v-icon>
              <v-card 
                class="d-flex justify-center"
                style="padding:20px; margin-right: 10px"
                outlined
                v-if="file.attachmentId == null">
                <v-img height="80" width="80"
                  :src="getImage(file)">
                </v-img>
                <v-card-text>
                  {{file.name.length > 20 ? `${file.name.substring(0, 17)}...` : file.name}}
                </v-card-text>
              </v-card>
              <v-card 
                class="d-flex justify-center"
                style="padding:20px; margin-right: 10px;"                        
                outlined
                v-if="file.attachmentId != null"
                @click="downloadFile(file)">
                <v-img height="80" width="80"
                  :src="getImage(file)">
                </v-img>
                <v-card-text>
                  {{file.fileName.length > 20 ? `${file.fileName.substring(0, 17)}...` : file.fileName}}
                </v-card-text>
              </v-card>  
            </div>
          </div>
        </v-row>

        <v-row justify="center" v-if="!disabledOrder" style="margin-top:30px;margin-bottom:10px">
          <v-file-input
            accept="image/*;capture=camera"
            label="File input"
            multiple
            v-show="false"
            ref="inputUpload"
            @change="changeFile"
          ></v-file-input>
        </v-row>
        <v-row style="margin-left:0px; margin-bottom:20px;" align="center" justify="center">
          <v-btn
            color="primary"
            style="color:white"
            @click="sendFile"
            v-if="!disabledOrder"
          >
            Upload de Arquivo
            <v-icon
              right
              dark
            >
              mdi-cloud-upload
            </v-icon>
          </v-btn>
        </v-row>

        <v-switch
          style="margin-top: 0px;"
          v-model="order.showSimpleReport"
          inset
          label="Exibir Relatório Simplificado"
          :disabled="disabledOrder"
        ></v-switch>

        <v-switch
          style="margin-top: 0px;"
          v-model="order.hideInReport"
          inset
          label="Ocultar Acréscimo/Desconto/Adicional Em Relatório"
          :disabled="disabledOrder"
        ></v-switch>

        <v-switch
          style="margin-top: 0px;"
          v-model="order.showNotesInReport"
          inset
          label="Mostrar Observações No Relatório"
          :disabled="disabledOrder"
        ></v-switch>

        <v-textarea
          v-model="order.obsInReport"
          label="Observações no Relatório"
          auto-grow
          outlined
          rows="4"
          row-height="20"
          style="border-radius:12px"
          maxlength="100"
          :disabled="disabledOrder"
        ></v-textarea>

        <v-textarea
          v-model="order.descriptionInNF"
          label="Descrição Complementar de NF"
          auto-grow
          outlined
          rows="4"
          row-height="20"
          style="border-radius:12px"
          maxlength="500"
          :disabled="disabledOrder"
        ></v-textarea>

        <v-select
          v-model="order.listResponsiblesSelected"
          :items="listResponsibles"
          item-disabled="disable"
          chips
          label="Responsáveis"
          multiple
          outlined
          :disabled="disabledOrder"
        ></v-select>

        <v-row align="center" justify="center" v-if="showBtn">
          <v-btn
            color="primary"
            style="margin-bottom:60px; color:white"
            @click="next1"
          >
            Próximo
          </v-btn>
        </v-row>

        <v-bottom-sheet v-model="sheetClient" scrollable>
          <v-card>
            <v-card-title>Selecione o Cliente</v-card-title>
            <v-text-field
              style="margin-left:10px; margin-right:10px"
              label="Filtro"
              solo
              v-model="client.filter"
              @keyup="changeFilterClient"
              autocomplete="off"
            ></v-text-field>
            <v-divider></v-divider>
            <v-card-text style="height: 500px;">
              <div v-for="(client, index) in client.listClients" :key="index">
                <div @click="changeClient(client)">
                  <sigCardInformation
                      :subtitles="client.subtitles"
                      :componentCurrent="component"
                      :classCard="'pa-0'"
                      :styleCard="
                        'margin:10px'
                      "
                      :classSubtitle="'text-body-1'"
                  ></sigCardInformation>
                </div>
              </div>
              <div class="text-center">
                <v-pagination
                  v-model="paginationClient.page"
                  :length="paginationClient.length"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="changePageClient"
                ></v-pagination>
              </div>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>
        <v-bottom-sheet v-model="sheetProvider" scrollable>
          <v-card>
            <v-card-title>Selecione o Fornecedor</v-card-title>
            <v-text-field
              style="margin-left:10px; margin-right:10px"
              label="Filtro"
              solo
              v-model="provider.filter"
              @keyup="changeFilterProvider"
              autocomplete="off"
            ></v-text-field>
            <v-divider></v-divider>
            <v-card-text style="height: 500px;">
              <div v-for="(provider, index) in provider.listProvider" :key="index">
                <div @click="changeProvider(provider)">
                  <sigCardInformation
                    :subtitles="provider.subtitles"
                    :componentCurrent="component"
                    :classCard="'pa-0'"
                    :styleCard="
                      'margin:10px'
                    "
                    :classSubtitle="'text-body-1'"
                  ></sigCardInformation>
                </div>
              </div>
              <div class="text-center">
                <v-pagination
                  v-model="paginationProvider.page"
                  :length="paginationProvider.length"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="changePageProvider"
                ></v-pagination>
              </div>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>
        <v-btn
          v-if="orderId != null && orderId != 0"
          color="primary"
          dark
          fab
          fixed
          right
          bottom
          class="btnForward"
          @click="sheetOptions = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
        <v-dialog
          v-model="dialogForward"
        >
          <v-card>
            <v-card-title class="headline">
              Encaminhar {{labelOrder}}: {{order.code}}
            </v-card-title>
            <v-row style="margin-bottom: -50px;">
              <v-col  
                class="d-flex"
                cols="12"
                sm="12"
                style="padding: 25px;"
              >
                <simple-select 
                  :model="forward.sectorSelected"
                  :label=labelDepartment
                  :items="listSector.items"
                  v-on:valueChanged="changeSectorForward"
                ></simple-select>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -50px;">
              <v-col  
                class="d-flex"
                cols="12"
                sm="12"
                style="padding: 25px;"
              >
                <v-select
                  v-model="forward.listResponsiblesSelected"
                  :items="listResponsibles"
                  chips
                  label="Responsáveis"
                  multiple
                  outlined
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col  
                class="d-flex"
                cols="12"
                sm="12"
                style="padding: 25px;"
              >
                <v-textarea
                  label="Deixe um Comentário (Opcional)"
                  outlined
                  rows="2"
                  name="input-7-4"
                  v-model="forward.text"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="green darken-1"
                text
                @click="closeDialogForwardOrder"
              >
                Fechar
              </v-btn>
              <v-btn
                color="green darken-1"
                text
                @click="forwardOrder"
              >
                Encaminhar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div v-if="value == 1" class="bottomNavigation1"> 
        <v-btn
          v-if="orderId != null && orderId != 0"
          color="primary"
          dark
          fab
          fixed
          right
          bottom
          class="btnForward"
          @click="sheetOptions = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
        <v-row style="margin-top: 10px;">
          <v-col 
            cols="6"
            sm="6"
            v-if="canView.withdrawalDate.show"
          >
            <v-dialog
              ref="withdrawalDate"
              v-model="withdrawalDate.show"
              :return-value.sync="order.withdrawalDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatWithdrawalDate"
                  :label="canView.withdrawalDate.text != null && canView.withdrawalDate.text != '' ? canView.withdrawalDate.text : 'Data Retirada'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  style="border-radius:12px"
                  :disabled="disabledOrder"
                ></v-text-field>
              </template>
                <v-date-picker
                  locale="pt-br"
                  v-model="order.withdrawalDate"
                  scrollable
                >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="order.withdrawalDate = ''; $refs.withdrawalDate.save(order.withdrawalDate); withdrawalDate.show = false"
                    >
                      Limpar
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="withdrawalDate.show = false"
                    >
                      Voltar
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.withdrawalDate.save(order.withdrawalDate)"
                    >
                      Ok
                    </v-btn>
                </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col 
            cols="6"
            sm="6"
            v-if="canView.withdrawalHour.show"
          >
            <v-dialog
              ref="withdrawalHour"
              v-model="withdrawalDate.showHour"
              :return-value.sync="order.withdrawalHour"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="order.withdrawalHour"
                  :label="canView.withdrawalHour.text != null && canView.withdrawalHour.text != '' ? canView.withdrawalHour.text : 'Hora de Retirada'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  style="border-radius:12px"
                  :disabled="disabledOrder"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="withdrawalDate.showHour"
                v-model="order.withdrawalHour"
                format="24hr"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="order.withdrawalHour = ''; $refs.withdrawalHour.save(order.withdrawalHour); withdrawalDate.showHour = false"
                >
                  Limpar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="withdrawalDate.showHour = false"
                >
                  Voltar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.withdrawalHour.save(order.withdrawalHour)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            v-if="canView.pickupLocation.show"
          >
            <v-textarea
              v-model="order.pickupLocation"
              :label="canView.pickupLocation.text != null && canView.pickupLocation.text != '' ? canView.pickupLocation.text : 'Local de Retirada'"
              auto-grow
              outlined
              rows="2"
              row-height="20"
              style="border-radius:12px"
              maxlength="150"
              :disabled="disabledOrder"
            ></v-textarea>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            v-if="canView.qtdInstallersWithdrawal.show"
          >
            <v-text-field
              type="number"
              v-model="order.qtdInstallersWithdrawal"
              :label="canView.qtdInstallersWithdrawal.text != null && canView.qtdInstallersWithdrawal.text != '' ? canView.qtdInstallersWithdrawal.text : 'Qtd Instaladores Retirada'"
              outlined
              style="border-radius:12px;"
              :disabled="disabledOrder"
            ></v-text-field>
          </v-col>
          <v-col
            cols="6"
            sm="6"
            v-if="canView.typeDeliveryWithdrawalSelected.show"
          >
            <v-select
              :items="typeDelivery"
              v-model="order.typeDeliveryWithdrawalSelected"
              :label="canView.typeDeliveryWithdrawalSelected.text != null && canView.typeDeliveryWithdrawalSelected.text != '' ? canView.typeDeliveryWithdrawalSelected.text : 'Transporte Retirada'"
              style="border-radius:12px"
              outlined
              :disabled="disabledOrder"
            ></v-select>
          </v-col>
          <v-col 
            cols="6"
            sm="6"
            v-if="canView.deliveryDate.show"
          >
            <v-dialog
              ref="deliveryDate"
              v-model="deliveryDate.show"
              :return-value.sync="order.deliveryDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatDeliveryDate"
                  :label="canView.deliveryDate.text != null && canView.deliveryDate.text != '' ? canView.deliveryDate.text : 'Data de Entrega'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  style="border-radius:12px"
                  :disabled="disabledOrder"
                ></v-text-field>
              </template>
                <v-date-picker
                  locale="pt-br"
                  v-model="order.deliveryDate"
                  scrollable
                >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="order.deliveryDate = ''; $refs.deliveryDate.save(order.deliveryDate); deliveryDate.show = false"
                    >
                      Limpar
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="deliveryDate.show = false"
                    >
                      Voltar
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.deliveryDate.save(order.deliveryDate)"
                    >
                      Ok
                    </v-btn>
                </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col 
            cols="6"
            sm="6"
            v-if="canView.deliveryHour.show"
          >
            <v-dialog
              ref="deliveryHour"
              v-model="deliveryDate.showHour"
              :return-value.sync="order.deliveryHour"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="order.deliveryHour"
                  :label="canView.deliveryHour.text != null && canView.deliveryHour.text != '' ? canView.deliveryHour.text : 'Hora de Entrega'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  style="border-radius:12px"
                  :disabled="disabledOrder"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="deliveryDate.showHour"
                v-model="order.deliveryHour"
                format="24hr"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="order.deliveryHour = ''; $refs.deliveryHour.save(order.deliveryHour); deliveryDate.showHour = false"
                >
                  Limpar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="deliveryDate.showHour = false"
                >
                  Voltar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.deliveryHour.save(order.deliveryHour)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            v-if="canView.deliveryPlace.show"
          >
            <v-textarea
              v-model="order.deliveryPlace"
              :label="canView.deliveryPlace.text != null && canView.deliveryPlace.text != '' ? canView.deliveryPlace.text : 'Local de Entrega'"
              auto-grow
              outlined
              rows="2"
              row-height="20"
              style="border-radius:12px"
              maxlength="100"
              :disabled="disabledOrder"
            ></v-textarea>
          </v-col>
          <v-col
            class="d-flex"
            cols="12"
            sm="12"
            v-if="canView.typeDeliverySelected.show"
          >
            <v-select
              :items="typeDelivery"
              v-model="order.typeDeliverySelected"
              :label="canView.typeDeliverySelected.text != null && canView.typeDeliverySelected.text != '' ? canView.typeDeliverySelected.text : 'Tipo Entrega'"
              style="border-radius:12px"
              outlined
              :disabled="disabledOrder"
            ></v-select>
          </v-col>
          <v-col 
            cols="6"
            sm="6"
            v-if="canView.installDate.show"
          >
            <v-dialog
              ref="installDate"
              v-model="installDate.show"
              :return-value.sync="order.installDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="formatInstallDate"
                  :label="canView.installDate.text != null && canView.installDate.text != '' ? canView.installDate.text : 'Data da Instalação'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  style="border-radius:12px"
                  :disabled="disabledOrder"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="order.installDate"
                scrollable
              >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="order.installDate = ''; $refs.installDate.save(order.installDate); installDate.show = false"
                  >
                    Limpar
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="installDate.show = false"
                  >
                    Voltar
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.installDate.save(order.installDate)"
                  >
                    Ok
                  </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col 
            cols="6"
            sm="6"
            v-if="canView.installHour.show"
          >
            <v-dialog
              ref="installHour"
              v-model="installDate.showHour"
              :return-value.sync="order.installHour"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="order.installHour"
                  :label="canView.installHour.text != null && canView.installHour.text != '' ? canView.installHour.text : 'Hora da Instalação'"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  outlined
                  style="border-radius:12px"
                  :disabled="disabledOrder"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="installDate.showHour"
                v-model="order.installHour"
                format="24hr"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="order.installHour = ''; $refs.installHour.save(order.installHour); installDate.showHour = false"
                >
                  Limpar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="installDate.showHour = false"
                >
                  Voltar
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.installHour.save(order.installHour)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            v-if="canView.installPlace.show"
          >
            <v-textarea
              v-model="order.installPlace"
              :label="canView.installPlace.text != null && canView.installPlace.text != '' ? canView.installPlace.text : 'Local de Instalação'"
              auto-grow
              outlined
              rows="2"
              row-height="20"
              style="border-radius:12px"
              maxlength="100"
              :disabled="disabledOrder"
            ></v-textarea>
          </v-col>
          <v-col
            class="d-flex"
            cols="12"
            sm="12"
            v-if="canView.qtdInstallers.show"
          >
            <v-text-field
              type="number"
              v-model="order.qtdInstallers"
              :label="canView.qtdInstallers.text != null && canView.qtdInstallers.text != '' ? canView.qtdInstallers.text : 'Qtd Instaladores'"
              outlined
              style="border-radius:12px;"
              :disabled="disabledOrder"
            ></v-text-field>
          </v-col>
          <v-col 
            cols="12"
            sm="12"
            v-if="canView.responsibleName.show"
          >
            <v-text-field
              v-model="order.responsibleName"
              :label="canView.responsibleName.text != null && canView.responsibleName.text != '' ? canView.responsibleName.text : 'Nome do Responsável'"
              outlined
              style="border-radius:12px"
              maxlength="50"
              :disabled="disabledOrder"
            ></v-text-field>
          </v-col>
          <v-col 
            cols="12"
            sm="12"
            v-if="canView.responsiblePhone.show"
          >
            <v-text-field
              v-model="order.responsiblePhone"
              :label="canView.responsiblePhone.text != null && canView.responsiblePhone.text != '' ? canView.responsiblePhone.text : 'Celular do Responsável'"
              outlined
              style="border-radius:12px"
              maxlength="20"
              :disabled="disabledOrder"
            ></v-text-field>
          </v-col>
          <v-col 
            cols="12"
            sm="12"
            v-if="canView.responsibleEmail.show"
          >
            <v-text-field
              v-model="order.responsibleEmail"
              :label="canView.responsibleEmail.text != null && canView.responsibleEmail.text != '' ? canView.responsibleEmail.text : 'E-mail do Responsável'"
              outlined
              style="border-radius:12px"
              maxlength="50"
              :disabled="disabledOrder"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            v-if="canView.paymentConditions.show"
          >
            <v-textarea
              v-model="order.paymentConditions"
              :label="canView.paymentConditions.text != null && canView.paymentConditions.text != '' ? canView.paymentConditions.text : 'Condições de pagamento'"
              auto-grow
              outlined
              rows="2"
              row-height="20"
              style="border-radius:12px"
              maxlength="50"
              :disabled="disabledOrder"
            ></v-textarea>
          </v-col>
        </v-row>

        <v-row align="center" justify="center" v-if="showBtn">
          <v-btn
            color="primary"
            style="margin-bottom:60px; margin-right:10px; color:white"
            @click="back0"
          >
            Voltar
          </v-btn>
          <v-btn
            color="primary"
            style="margin-bottom:60px; color:white"
            @click="next2"
          >
            Próximo
          </v-btn>
        </v-row>
      </div>
      <div v-if="value == 2">
        <v-btn
          v-if="orderId != null && orderId != 0"
          color="primary"
          dark
          fab
          fixed
          right
          bottom
          class="btnPlus"
          @click="sheetOptions = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
        </v-btn>
        <v-btn
          color="primary"
          dark
          fab
          fixed
          right
          bottom
          class="btnPlus"
          @click="dialogAddProduct = true"
          v-if="showBtn"
        >
          <v-icon>
            mdi-cart-plus
          </v-icon>
        </v-btn>
        <v-container>
          <v-row>
            <v-expansion-panels focusable>
              <v-expansion-panel
                v-for="(item,i) in order.productsSelectedOrder"
                :key="i"
              >
                <v-expansion-panel-header>
                  <b>
                    #{{i+1}} - {{item.productName}} 
                    {{item.obs1 != null && item.obs1 != "" ? `[${item.obs1}]` : ""}} 
                    {{canViewOrderValue ? `R$ ${parseFloat(item.totalItem).toFixed(2)}` : ""}} 
                    {{item.m3 != null && item.m3 > 0 ? `(Larg: ${parseFloat(item.width).toFixed(2)} Alt: ${parseFloat(item.height).toFixed(2)} Comp: ${parseFloat(item.length).toFixed(2)})` : ""}} 
                    {{item.m2 != null && item.m2 > 0 ? `(Larg: ${parseFloat(item.width).toFixed(2)} Alt: ${parseFloat(item.height).toFixed(2)})` : ""}}
                  </b>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-col class="text-right" style="margin-top: -25px;">
                    <v-icon @click="editItem(item, i)" color="green">mdi-pencil</v-icon>
                    <v-icon @click="removeItem(i)" color="red">mdi-delete</v-icon>
                  </v-col>
                  <div class="text-center" v-if="item.features.length == 0">Não há características.</div>
                  <div class="files"> 
                    <div v-for="(feat, index) in item.features" :key="index">
                      <v-card 
                        class="d-flex justify-center"
                        style="margin-right: 10px; width: 200px"                        
                        outlined
                      >
                        <v-card-text>
                          <h3>
                            {{feat.title}}
                          </h3>
                          <div>{{feat.selected != null ? feat.selected.name : ""}}</div>
                        </v-card-text>
                      </v-card>  
                    </div>
                  </div>  
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <v-row align="center" justify="center" v-if="showBtn" style="margin-bottom:73px; margin-top:30px">
            <v-btn
              color="primary"
              style="margin-bottom:60px; margin-right:10px; color:white"
              @click="back1"
            >
              Voltar
            </v-btn>
            <v-btn
              color="primary"
              style="margin-bottom:60px; color:white"
              @click="finishOrder"
            >
              Finalizar
            </v-btn>
          </v-row>
          <!--<v-row align="center" justify="center" v-if="order.code" style="margin-bottom:73px; margin-top:30px">
            <v-btn
              color="primary"
              style="margin-bottom:60px; color:white"
              @click="updateOrder"
            >
              Atualizar
            </v-btn>
          </v-row>-->
        </v-container>

        <v-dialog
          v-model="dialogAddProduct"
          fullscreen
          hide-overlay
          transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
              dark
              color="primary"
            >
              <v-btn
                icon
                dark
                @click="closeAddProduct"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-toolbar-title>Adicionar Item</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn
                  icon
                  dark
                  @click="scanItem"
                  v-if="showQrCode"
                >
                  <v-icon>mdi-qrcode-scan</v-icon>
                </v-btn>
                <v-btn
                  icon
                  dark
                  @click="addItem"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-container>
              <h2 style="color:rgb(124,131,124);">Produto</h2>
              <span v-if="product.selected != null">{{product.selected.subtitles[1].value}}</span>
              <b><p style="margin-bottom: 30px" :style="`color:${$vuetify.theme.defaults.light.primary}`" @click="sheetProduct = true">{{product.selected != null && product.selected.subtitles[1].value != "Selecione o Produto" ? "Trocar" : "Selecione"}} o produto</p></b>
              
              <v-row v-if="product.productAllData.taxedUnit == 6 || product.productAllData.taxedUnit == 7">
                <v-col 
                  cols="6"
                  sm="6"
                >
                  <v-text-field
                    @keyup="changeMeters()"
                    type="number"
                    v-model="width"
                    label="Largura"
                    outlined
                    style="border-radius:12px"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-text-field
                    @keyup="changeMeters()"
                    type="number"
                    v-model="height"
                    label="Altura"
                    outlined
                    style="border-radius:12px"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row v-if="product.productAllData.taxedUnit == 6">
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-text-field
                    :value="width * height"
                    type="number"
                    label="M²"
                    outlined
                    disabled
                    style="border-radius:12px"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-row v-if="product.productAllData.taxedUnit == 7">
                <v-col 
                  cols="6"
                  sm="6"
                >
                  <v-text-field
                    @keyup="changeMeters()"
                    type="number"
                    v-model="length"
                    label="Comprimento"
                    outlined
                    style="border-radius:12px"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                >
                  <v-text-field
                    type="number"
                    :value="width * height * length"
                    label="M³"
                    disabled
                    outlined
                    style="border-radius:12px"
                  ></v-text-field>
                </v-col>
              </v-row>

              <v-textarea
                v-if="product.productAllData.obs != null && product.productAllData.obs != ''"
                v-model="product.productAllData.obs"
                label="Observações do Produto:"
                auto-grow
                outlined
                rows="5"
                row-height="20"
                style="border-radius:12px"
                :disabled="true"
                filled
              ></v-textarea>

              <v-row>
                <v-col 
                  cols="6"
                  sm="6"
                >
                  <v-text-field
                    type="number"
                    v-model="quantity"
                    label="Quantidade"
                    outlined
                    style="border-radius:12px"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="6"
                  sm="6"
                  v-show="canViewOrderValue"
                >
                  <v-text-field-money
                    :value="((parseFloat(totalItem) * (product.productAllData.taxedUnit == 6 ? (width * height) : product.productAllData.taxedUnit == 7 ? (width * height * length) : 1) * quantity) + (parseFloat(featuresValue) * quantity) + parseFloat(additionItem) - parseFloat(discountItem))"
                    label="Total Item"
                    v-bind:properties="{
                      prefix: 'R$',
                      readonly: false,
                      disabled: true,
                      outlined: true,
                      clearable: false,
                      placeholder: '',
                      style:'border-radius:12px'
                    }"
                    v-bind:options="{
                      locale: 'pt-BR',
                      length: 11,
                      precision: 2,
                      empty: null,
                    }"
                  />
                </v-col>
              </v-row>

              <v-text-field
                v-model="name"
                label="Obs"
                outlined
                style="border-radius:12px"
              ></v-text-field>

              <v-row>
                <v-col  
                  cols="6"
                  sm="6"
                  v-show="canViewOrderValue"
                >
                  <v-text-field-money
                    v-model="additionItem"
                    label="Acrescimo"
                    v-bind:properties="{
                      prefix: 'R$',
                      readonly: false,
                      disabled: false,
                      outlined: true,
                      clearable: false,
                      placeholder: '',
                      style:'border-radius:12px'
                    }"
                    v-bind:options="{
                      locale: 'pt-BR',
                      length: 11,
                      precision: 2,
                      empty: 0.00,
                    }"
                  />
                </v-col>
                <v-col  
                  cols="6"
                  sm="6"
                  v-show="canViewOrderValue"
                >
                  <v-text-field-money
                    v-model="discountItem"
                    label="Desconto"
                    v-bind:properties="{
                      prefix: 'R$',
                      readonly: false,
                      disabled: false,
                      outlined: true,
                      clearable: false,
                      placeholder: '',
                      style:'border-radius:12px'
                    }"
                    v-bind:options="{
                      locale: 'pt-BR',
                      length: 11,
                      precision: 2,
                      empty: 0.00,
                    }"
                  />
                </v-col>
              </v-row>

              <div v-if="featuresShow.length > 0">
                <h2 style="color:rgb(124,131,124); margin-bottom:10px">Características</h2>
                <div class="files"> 
                  <div v-for="(feat, index) in featuresShow" :key="index" style="width: 200px; margin-right: 10px;">
                    <v-card 
                      class="d-flex justify-center"
                      style="width: 200px"                        
                      outlined
                      @click="addFeatures(feat)"
                    >
                      <v-icon 
                        v-if="feat.selected != null"
                        color="green darken-2" :style="iconInfo"
                      >
                        mdi-check-decagram
                      </v-icon> 
                      <v-icon 
                        v-if="feat.selected == null"
                        color="red" :style="iconInfo"
                      >
                        mdi-alert-decagram
                      </v-icon>
                      <v-card-text>
                        <h3>
                          {{feat.title}}
                        </h3>
                        <div>{{feat.selected != null ? feat.selected.name : ""}}</div>
                      </v-card-text>
                    </v-card>  
                  </div>
                </div>
              </div>
            </v-container>
          </v-card>
        </v-dialog>
        
        <v-footer outlined fixed class="totalOrder" v-show="canViewOrderValue">
          <v-col  
            cols="4"
            sm="4"
            style="margin-left:-20px;flex: 1 0 33.333333%;max-width: 40.333333%;"
          >
            <v-text-field-money
              v-model="order.addition"
              label="Acrescimo"
              v-bind:properties="{
                prefix: 'R$',
                readonly: false,
                disabled: false,
                outlined: true,
                clearable: false,
                placeholder: '',
                style:'border-radius:12px'
              }"
              v-bind:options="{
                locale: 'pt-BR',
                length: 11,
                precision: 2,
                empty: null,
              }"
            />
          </v-col>
          <v-col  
            cols="4"
            sm="4"
            style="margin-left:-15px;flex: 1 0 33.333333%;max-width: 40.333333%;"
          >
            <v-text-field-money
              v-model="order.discount"
              label="Desconto"
              v-bind:properties="{
                prefix: 'R$',
                readonly: false,
                disabled: false,
                outlined: true,
                clearable: false,
                placeholder: '',
                style:'border-radius:12px'
              }"
              v-bind:options="{
                locale: 'pt-BR',
                length: 11,
                precision: 2,
                empty: null,
              }"
            />
          </v-col>
          <v-col  
            cols="4"
            sm="4"
            style="margin-left:-15px;flex: 1 0 33.333333%;max-width: 40.333333%;margin-bottom: 27px;"
          >
            <span style="color:red"><b>Total Pedido:</b></span>
            <br>
            <span style="color:red"><b>R$ {{(order.totalOrder + (order.addition == "" || order.addition == null ? 0 : parseFloat(order.addition)) - (order.discount == "" || order.discount == null ? 0 : parseFloat(order.discount))).toFixed(2)}}</b></span>
          </v-col>
        </v-footer>

        <v-dialog
          v-model="dialogFeature"
          scrollable
          max-width="300px"
          persistent
        >
          <v-card>
            <v-card-title>{{featureSelected != null ? featureSelected.title : "Característica"}}</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 300px;">
            <v-radio-group
              v-model="featureSelectedRadio"
              column
            >
              <v-radio v-for="(radio, index) in listRadio" :key="index"
                :label="radio.name"
                :value="radio"
              ></v-radio>
            </v-radio-group>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
                color="blue darken-1"
                text
                @click="dialogFeature = false"
            >
                Fechar
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="pressSelect"
            >
                Selecionar
            </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-bottom-sheet v-model="sheetProduct" scrollable>
          <v-card>
            <v-card-title>Selecione o Produto</v-card-title>
            <v-text-field
              style="margin-left:10px; margin-right:10px"
              label="Filtro"
              solo
              v-model="product.filter"
              @keyup="changeFilterProduct"
              autocomplete="off"
            ></v-text-field>
            <v-divider></v-divider>
            <v-card-text style="height: 500px;">
              <div v-for="(product, index) in product.listProducts" :key="index">
                <div @click="changeProduct(product)">
                  <sigCardInformation
                    :subtitles="product.subtitles"
                    :componentCurrent="component"
                    :classCard="'pa-0'"
                    :styleCard="
                      'margin:10px'
                    "
                    :classSubtitle="'text-body-1'"
                  ></sigCardInformation>
                </div>
              </div>
              <div class="text-center">
                <v-pagination
                  v-model="paginationProduct.page"
                  :length="paginationProduct.length"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                  @input="changePageProduct"
                ></v-pagination>
              </div>
            </v-card-text>
          </v-card>
        </v-bottom-sheet>
      </div>
      <div v-if="value == 3" class="bottomNavigation">
        <div v-for="(interaction, index) in history" :key="index">
          <v-row class="d-flex flex-row-reverse" style="margin-bottom:15px">
            <v-col
              class="d-flex"
              cols="3"
              sm="3"
            >
              <v-avatar color="#DCDCDC" size="62">
                <span class="white--text headline">{{interaction.initials}}</span>
              </v-avatar>
            </v-col>
            <v-col style="text-align:right">
              <span><b>{{interaction.name}}</b></span>
              <br>
              <span style="font-size:15px">{{interaction.email}}</span>
              <br>
              <span style="font-size:15px">{{interaction.date}}</span>
            </v-col>
            <v-col
              cols="12"
              sm="12"
              style="margin-top: -12px;"
            >
              <div class="d-flex justify-end" style="margin-bottom:10px" v-if="canEdit || canDelete">
                <v-icon v-if="canEdit && interaction.text.startsWith('Comentário:')" @click="onLongPressStartEdit(interaction)" color="green">mdi-pencil</v-icon>
                <v-icon v-if="canDelete && interaction.text.startsWith('Comentário:')" @click="onLongPressStartDelete(interaction)" color="red">mdi-delete</v-icon>    
              </div>
              <v-card class="elevation-2 d-flex justify-end" shaped>
                <v-card-text v-html="interaction.text"></v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <v-bottom-navigation
      v-model="value"
      color="white"
      :background-color="color"
      app
      fixed
      grow
    >
      <v-btn :disabled="disabled0" @click="changeMenu(0)">
        <span>Dados</span>
        <v-icon>mdi-card-account-details</v-icon>
      </v-btn>

      <v-btn v-show="showDates" :disabled="disabled1" @click="changeMenu(1)">
        <span>Datas</span>
        <v-icon>mdi-calendar-text</v-icon>
      </v-btn>

      <v-btn :disabled="disabled2" @click="changeMenu(2)">
        <span>Items</span>
        <v-icon>mdi-currency-usd</v-icon>
      </v-btn>
      
      <v-btn @click="goHistory" v-if="orderId != null && orderId != 0">
        <span>Histórico</span>
        <v-icon>mdi-message-text</v-icon>
      </v-btn>
    </v-bottom-navigation>

    <v-dialog
      persistent
      v-model="dialogAction"
    >   
      <v-card style="padding: 15px;">
        <h2 class="text-center">Anexo</h2>
        <br>

        <v-text-field
          v-model="linkDownloadFile"
          ref="textToCopy"
          label="Link"
          outlined
          style="border-radius:12px"
          :readonly="true"
        ></v-text-field>

        <v-row justify="center" style="margin-bottom:10px">
          <v-btn
            style="margin-right:20px"
            @click="dialogAction = false"
          >
            Voltar
          </v-btn>
          <v-btn 
            color="primary"
            style="color:white"
            @click="copyText"
          >
            Copiar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="dialog.show"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{dialog.title}}
        </v-card-title>

        <v-card-text>
          {{dialog.message}}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialog.show = false"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConfirm"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Exclusão
        </v-card-title>

        <v-card-text>
          Confirma Exclusão do Registro?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="dialogConfirm = false"
          >
            Não
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDelete"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogRemoveAttachment"
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Exclusão
        </v-card-title>

        <v-card-text>
          Confirma Exclusão do Anexo?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            text
            @click="cancelRemoveAttachment"
          >
            Não
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="confirmRemoveAttachment"
          >
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogEdit"
    >
      <v-card>
        <v-card-title class="headline">
          Alterar Iteração
        </v-card-title>

        <v-card-text>
          Digite o Novo Conteúdo
        </v-card-text>
        <v-row>
          <v-col  
            class="d-flex"
            cols="12"
            sm="12"
            style="padding: 25px;"
          >
            <v-textarea
              solo
              rows="2"
              name="input-7-4"
              value=""
              v-model="historyEdit.text"
            ></v-textarea>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="dialogEdit = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="updateHistory"
          >
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheetOptions">
      <v-list>
        <v-list-item
          v-for="(option, index) in options"
          :key="index"
          @click="clickOption(option)"
        >
          <v-list-item-avatar>
            <v-icon
              color="primary"
              medium
            >
              {{ option.icon }}
            </v-icon>
          </v-list-item-avatar>
          <v-list-item-title>{{ option.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-bottom-sheet>
  </v-container>
</template>
<script>
  import SimpleSelect from '../../../components/selects/SimpleSelect';
  import CardInformation from "../../../components/card/CardInformation";
  import TextCard from "../../../components/card/TextCard";
  import CrudService from '../../../services/CrudService';

  import moment from 'moment';

  export default {

    components: {
      "sigCardInformation": CardInformation,
      "simple-select": SimpleSelect
    },

    data: () => ({ 
      showQrCode: false,
      dialogRemoveAttachment: false,
      component: TextCard,
      sheetOptions: false,
      options: [{ icon: 'mdi-share', title: `Encaminhar`, go: "share" }],
      disabledOrder: false,
      editEnable: false,
      canEdit: false,
      canDelete: false,
      canRemoveAttachment: false,
      value: 0,
      orderId: 0,
      loginData: null,
      title: "",
      listStatus: {
        items: [
          {text: "Em Orçamento", value: 0},
          {text: "Orçamento Cancelado", value: 1},
          {text: "Pedido em Andamento", value: 2},
          {text: "Pedido Cancelado", value: 3},
          {text: "Pedido Finalizado", value: 4}
        ]
      },
      listSector: {
        items: []
      },
      labelDepartment: "",
      createDate: {
        show: false
      },
      emailClient: "",
      phoneClient: "",
      celClient: "",
      addressClient: "",
      sheetClient: false,
      sheetProvider: false,
      sheetProduct: false,
      client: {
        filter: "",
        listClients: [],
        listClientsBkp: [],
        listClientsFilter: [],
      },
      provider: {
        filter: "",
        listProvider: [],
        listProviderBkp: [],
        listProviderFilter: [],
      },
      product: {
        filter: "",
        listProducts: [],
        listProductsBkp: [],
        listProductsFilter: [], 
        selected: null,
        productAllData: {}
      },
      paginationClient: {
        length: 0,
        page: 1
      },
      paginationProvider: {
        length: 0,
        page: 1
      },
      paginationProduct: {
        length: 0,
        page: 1
      },
      listResponsibles: [],
      disabled0: false,
      disabled1: true,
      disabled2: true,
      showDates: false,
      withdrawalDate: {
        show: false,
        showHour: false
      },
      deliveryDate: {
        show: false,
        showHour: false
      },
      installDate: {
        show: false,
        showHour: false
      },
      typeDelivery: [
        {text: 'Nenhum', value: 0},
        {text: 'Carro', value: 1},
        {text: 'Moto', value: 2} 
      ],
      dialogFeature: false,
      dialogEdit: false,
      dialogAddProduct: false,
      featureSelected: null,
      featureSelectedRadio: null,
      listRadio: [],
      width: 0,
      height: 0,
      length: 0,
      quantity: 1,
      totalItem: 0,
      name: "",
      additionItem: 0,
      discountItem: 0,
      featuresShow: [],
      features: [],
      dialog: {
        show: false,
        title: '',
        message: ''
      },
      dialogForward: false,
      dialogConfirm: false,
      canView: {
        withdrawalDate: {
          show: false,
          text: ""
        },
        withdrawalHour: {
          show: false,
          text: ""
        },
        deliveryDate: {
          show: false,
          text: ""
        },
        deliveryHour: {
          show: false,
          text: ""
        },
        installDate: {
          show: false,
          text: ""
        },
        installHour: {
          show: false,
          text: ""
        },
        installPlace: {
          show: false,
          text: ""
        },
        qtdInstallers: {
          show: false,
          text: ""
        },
        qtdInstallersWithdrawal: {
          show: false,
          text: ""
        },
        responsibleEmail: {
          show: false,
          text: ""
        },
        responsibleName: {
          show: false,
          text: ""
        },
        responsiblePhone: {
          show: false,
          text: ""
        },
        paymentConditions: {
          show: false,
          text: ""
        },
        deliveryPlace: {
          show: false,
          text: ""
        },
        pickupLocation: {
          show: false,
          text: ""
        },
        typeDeliverySelected: {
          show: false,
          text: ""
        },
        typeDeliveryWithdrawalSelected: {
          show: false,
          text: ""
        },
      },
      forward: {
        sectorSelected: null, 
        listResponsiblesSelected: [],
        text: ""
      },
      order: {
        listStatusSelected: {text: "Em Orçamento", value: 0},
        clientSelected: null,
        sectorSelected: null, 
        createDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),       
        providerSelected: null,
        files: [],
        showSimpleReport: false,
        hideInReport: false,
        showNotesInReport: false,
        listResponsiblesSelected: [],
        withdrawalDate: "",
        withdrawalHour: "",
        deliveryDate: "",
        deliveryHour: "",
        installDate: "",
        installHour: "",
        installPlace: "",
        qtdInstallers: 0,
        qtdInstallersWithdrawal: 0,
        responsibleEmail: "",
        responsibleName: "",
        responsiblePhone: "",
        paymentConditions: "",
        deliveryPlace: "",
        pickupLocation: "",
        typeDeliverySelected: 0,
        typeDeliveryWithdrawalSelected: 0,
        obsInReport: "",
        descriptionInNF: "",
        addition: 0,
        discount: 0,
        totalOrder: 0,
        productsSelectedOrder: [],
        code: 0
      },
      featuresValue: 0,
      arrayRemove: [],
      indexEdit: -1,
      canViewOrderValue: false,
      showBtn: true,
      labelOrder: "",
      dialogAction: false,
      linkDownloadFile: "",
      history: [],
      historyDelete: null,
      historyEdit: {
        id: 0,
        text: ""
      },
      iconInfo: "",
      index: -1
    }),

    computed: {
      color () {
        switch (this.value) {
          case 0: return 'primary'
          case 1: return 'primary'
          case 2: return 'primary'
          case 3: return 'primary'
          default: return 'primary'
        }
      },
      formatDateInitial() {
        return this.order.createDate
        ? moment(this.order.createDate).format("DD/MM/YYYY")
        : "";
      },
      formatWithdrawalDate() {
        return this.order.withdrawalDate
        ? moment(this.order.withdrawalDate).format("DD/MM/YYYY")
        : "";
      },
      formatDeliveryDate() {
        return this.order.deliveryDate
        ? moment(this.order.deliveryDate).format("DD/MM/YYYY")
        : "";
      },
      formatInstallDate() {
        return this.order.installDate
        ? moment(this.order.installDate).format("DD/MM/YYYY")
        : "";
      },
    },

    methods: {
      back(){
        this.$router.push('listOrder');
      },
      getImage(file){
        let arrayName = file.attachmentId == null ? file.name.split('.') : file.fileName.split('.');
        let iconName = arrayName[arrayName.length-1];
        iconName = iconName.toLowerCase();

        if(iconName == "csv"){
          return `img/csv.png`;
        }
        else if(iconName == "doc" || iconName == "docx"){
          return `img/doc.png`;
        }
        else if(iconName == "exe"){
          return `img/exe.png`;
        }
        else if(iconName == "jpg" || iconName == "jpeg"){
          return `img/jpg.png`;
        }
        else if(iconName == "mp3"){
          return `img/mp3.png`;
        }
        else if(iconName == "iso" ){
          return `img/iso.png`;
        }
        else if(iconName == "mp4"){
          return `img/mp4.png`;
        }
        else if(iconName == "pdf"){
          return `img/pdf.png`;
        }
        else if(iconName == "png"){
          return `img/png.png`;
        }
        else if(iconName == "ppt" || iconName == "pptx"){
          return `img/ppt.png`;
        }
        else if(iconName == "txt"){
          return `img/txt.png`;
        }
        else if(iconName == "xls" || iconName == "xlsx"){
          return `img/xls.png`;
        }
        else if(iconName == "xml"){
          return `img/xml.png`;
        }
        else if(iconName == "zip" || iconName == "7z"){
          return `img/zip.png`;
        }
        else{
          return `img/documento.png`;
        }
      },
      sendFile(){
        this.$refs.inputUpload.$refs.input.click();
      },
      next1(){
        if(!this.showDates){
          this.next2();
        }
        else{
          this.disabled0 = true;
          this.disabled1 = false;
          this.disabled2 = true;
          this.value = 1;
        }
      },
      back1(){
        if(!this.showDates){
          this.back0();
        }
        else{
          this.disabled0 = true;
          this.disabled1 = false;
          this.disabled2 = true;
          this.value = 1;
        }
      },
      back0(){
        this.disabled1 = true;
        this.disabled0 = false;
        this.disabled2 = true;
        this.value = 0;
      },
      next2(){
        this.disabled0 = true;
        this.disabled1 = true;
        this.disabled2 = false;
        this.value = 2;
      },
      addFeatures(feature){
        this.listRadio = this.featuresRecursive(feature, this.features);
        
        this.featureSelected = feature;
        
        if(feature.selected != null){
          this.featureSelectedRadio = this.listRadio.find(f => {
            return f.id == feature.selected.id;
          });
        }
        else{
          this.featureSelectedRadio = null;
        }
        
        this.dialogFeature = true;
      },
      featuresRecursive(feature, list){
        let result = null;
        
        for(let i = 0; i < list.length; i++){
          if(list[i].id == feature.id)
            return list[i].details;
          else{
            for(let z = 0; z < list[i].details.length; z++)
              for(let n = 0; n < list[i].details[z].children.length; n++)
              {
                result = this.featuresRecursive(feature, list[i].details[z].children);

                if(result != null)
                  return result;
              }
          }
        }
        
        return result;
      },
      pressSelect(){
        let newFeatures = this.featuresShow.filter(f => {
          let result = f.father != this.featureSelectedRadio.father;

          if(!result)
            this.arrayRemove.push(f.id);

          if(this.arrayRemove.includes(f.father))
          {
            this.arrayRemove.push(f.id);
            return false;
          }

          return result;
        });
        
        this.arrayRemove = [];
        this.featuresShow = newFeatures;
        
        if(this.featureSelectedRadio.children.length > 0){
          for(let i = 0; i < this.featuresShow.length; i++){
            if(this.featuresShow[i].id == this.featureSelectedRadio.father){
              this.featuresShow[i].selected = this.featureSelectedRadio;

              for(let z = 0; z < this.featureSelectedRadio.children.length; z++){
                var exists = this.featuresShow.find(f => {
                  return f.id == this.featureSelectedRadio.children[z].id;
                });

                if(exists == null){
                  this.featuresShow.splice(i+1, 0, {
                    id: this.featureSelectedRadio.children[z].id,
                    title: this.featureSelectedRadio.children[z].title,
                    father: this.featureSelectedRadio.father,
                    selected: null
                  });
                  
                  i++;
                }
              }
            }
          }
        }
        else
        {
          for(let i = 0; i < this.featuresShow.length; i++)
            if(this.featuresShow[i].id == this.featureSelectedRadio.father)
              this.featuresShow[i].selected = this.featureSelectedRadio;
        }
        this.dialogFeature = false;
        this.featureSelectedRadio = null;

        this.featuresValue = 0;

        this.featuresShow.forEach(feature => {
          if(feature.selected != null)
            this.featuresValue += (feature.selected.value * (this.product.productAllData.taxedUnit == 6 ? this.height * this.width : this.product.productAllData.taxedUnit == 7 ? this.height * this.width * this.length : 1));
        });
      },
      closeAddProduct(){
        this.indexEdit = -1;
        
        this.width = 0;
        this.height = 0;
        this.length = 0;
        this.quantity = 1;
        this.totalItem = 0;
        this.featuresValue = 0;
        this.name = "";
        this.additionItem = 0;
        this.discountItem = 0;
        this.product.filter = "";
        this.product.listProductsFilter = [];
        this.product.selected = null;
        this.product.productAllData = {};
        this.featuresShow = [];

        this.dialogAddProduct = false;
      },
      async clickOption(option){
        this.sheetOptions = false;

        if(option.go == 'share'){
          this.dialogForward = true;
        }
        else if(option.go == 'editEnable'){
          this.options.pop();
          this.options.push({ icon: 'mdi-lock', title: `Bloquear Edição`, go: "editDisable" });

          if(this.value == 2)
            this.options.push({ icon: 'mdi-cart-plus', title: `Adicionar Item`, go: "addItem" });

          this.disabledOrder = false;
          this.editEnable = true;
        }
        else if(option.go == 'addItem'){
          this.dialogAddProduct = true;
        }
        else{
          if(this.value == 2)
            this.options.pop();

          this.options.pop();
          this.options.push({ icon: 'mdi-lock-open', title: `Habilitar Edição`, go: "editEnable" });

          this.disabledOrder = true;
          this.editEnable = false;
        }
      },
      addItem(){
        let hasNull = this.featuresShow.find(fe => {
          return fe.selected == null
        });
        
        if(hasNull == null || this.product.selected == null){
          if(this.product.selected != null){

            this.order.totalOrder = 0;

            let product = {
              productId: this.product.selected.productId,
              productName: this.product.selected.subtitles[1].value,
              totalItem: (parseFloat(this.featuresValue) * parseFloat(this.quantity)) + (parseFloat(this.totalItem) * parseFloat(this.quantity)) * (this.product.productAllData.taxedUnit == 6 ? (parseFloat(this.width) * parseFloat(this.height)) : this.product.productAllData.taxedUnit == 7 ? (parseFloat(this.width) * parseFloat(this.height) * parseFloat(this.length)) : 1) + parseFloat(this.additionItem) - parseFloat(this.discountItem),
              width: parseFloat(this.width),
              height: parseFloat(this.height),
              length: parseFloat(this.length),
              m2: parseFloat(this.width) * parseFloat(this.height),
              m3: parseFloat(this.length) * parseFloat(this.width) * parseFloat(this.height),
              quantity: parseFloat(this.quantity),
              obs1: this.name,
              additionItem: parseFloat(this.additionItem),
              discountItem: parseFloat(this.discountItem),
              features: this.featuresShow,
              unitValue: parseFloat(this.product.selected.subtitles[2].value)
            };

            if(this.indexEdit == -1)
              this.order.productsSelectedOrder.push(product);
            else
              this.order.productsSelectedOrder[this.indexEdit] = product;
    
            this.order.productsSelectedOrder.forEach(prod => {
              this.order.totalOrder += prod.totalItem;
            });

            this.width = 0;
            this.height = 0;
            this.length = 0;
            this.quantity = 1;
            this.totalItem = 0;
            this.featuresValue = 0;
            this.name = "";
            this.additionItem = 0;
            this.discountItem = 0;
            this.product.filter = "";
            this.product.listProductsFilter = [];
            this.product.selected = null;
            this.product.productAllData = {};
            this.featuresShow = [];

            this.dialogAddProduct = false;
          }
          else{
            this.dialog.title = "Erro";
            this.dialog.message = "Não há produto para adicionar";
            this.dialog.show = true;
          }
        }
        else{
          this.dialog.title = "Erro";
          this.dialog.message = "Preencha todas as características";
          this.dialog.show = true;
        }

        this.indexEdit = -1;
      },
      changePageProduct(page){
        let end = 50 * page;
        let initial = end - 50;
        this.product.listProducts = [];
        
        if(this.product.filter == ""){
          for(let i = initial; i < end; i++){
            this.product.listProducts.push({
              subtitles: [
                {key: "Código Interno:", value: this.product.listProductsBkp[i].internalCode},
                {key: "Descrição:", value: this.product.listProductsBkp[i].name},
                {key: "Preço de Venda: R$", value: parseFloat(this.product.listProductsBkp[i].unitValue).toFixed(2), show: this.canViewOrderValue ? null : false},
              ],
              productId: this.product.listProductsBkp[i].id
            })
          }
        }
        else{
          for(let i = initial; i < end; i++){
            this.product.listProducts.push({
              subtitles: [
                {key: "Código Interno:", value: this.product.listProductsFilter[i].internalCode},
                {key: "Descrição:", value: this.product.listProductsFilter[i].name},
                {key: "Preço de Venda: R$", value: parseFloat(this.product.listProductsFilter[i].unitValue).toFixed(2), show: this.canViewOrderValue ? null : false},
              ],
              productId: this.product.listProductsFilter[i].id
            })
          }
        }
      },
      changePageClient(page){
        let end = 50 * page;
        let initial = end - 50;
        this.client.listClients = [];
        
        if(this.client.filter == ""){
          for(let i = initial; i < end; i++){
            if(this.client.listClientsBkp[i].typePerson == 0 || this.client.listClientsBkp[i].typePerson == 2){
              this.client.listClients.push({
                subtitles: [
                  {key: "Nome Fantasia:", value: this.client.listClientsBkp[i].fantasyName},
                  {key: "Razão Social:", value: this.client.listClientsBkp[i].companyName},
                  {key: "CNPJ:", value: this.client.listClientsBkp[i].document},
                ],
                clientId: this.client.listClientsBkp[i].id
              })
            }
            else{
              this.client.listClients.push({
                subtitles: [
                  {key: "Nome:", value: this.client.listClientsBkp[i].fantasyName},
                  {key: "Apelido:", value: this.client.listClientsBkp[i].companyName},
                  {key: "CPF:", value: this.client.listClientsBkp[i].document},
                ],
                clientId: this.client.listClientsBkp[i].id
              })
            }
          }
        }
        else{
          for(let i = initial; i < end; i++){
            if(this.client.listClientsBkp[i].typePerson == 0 || this.client.listClientsBkp[i].typePerson == 2){
              this.client.listClients.push({
                subtitles: [
                  {key: "Nome Fantasia:", value: this.client.listClientsFilter[i].fantasyName},
                  {key: "Razão Social:", value: this.client.listClientsFilter[i].companyName},
                  {key: "CNPJ:", value: this.client.listClientsFilter[i].document},
                ],
                clientId: this.client.listClientsFilter[i].id
              })
            }
            else{
              this.client.listClients.push({
                subtitles: [
                  {key: "Nome:", value: this.client.listClientsFilter[i].fantasyName},
                  {key: "Apelido:", value: this.client.listClientsFilter[i].companyName},
                  {key: "CPF:", value: this.client.listClientsFilter[i].document},
                ],
                clientId: this.client.listClientsFilter[i].id
              })
            }
          }
        }
      },
      changePageProvider(page){
        let end = 50 * page;
        let initial = end - 50;
        this.provider.listProvider = [];
        
        if(this.provider.filter == ""){
          for(let i = initial; i < end; i++){
            if(this.provider.listProviderBkp[i].typePerson == 0 || this.provider.listProviderBkp[i].typePerson == 2){
              this.provider.listProvider.push({
                subtitles: [
                  {key: "Nome Fantasia:", value: this.provider.listProviderBkp[i].fantasyName},
                  {key: "Razão Social:", value: this.provider.listProviderBkp[i].companyName},
                  {key: "CNPJ:", value: this.provider.listProviderBkp[i].document},
                ],
                providerId: this.provider.listProviderBkp[i].id
              })
            }
            else{
              this.provider.listProvider.push({
                subtitles: [
                  {key: "Nome:", value: this.provider.listProviderBkp[i].fantasyName},
                  {key: "Apelido:", value: this.provider.listProviderBkp[i].companyName},
                  {key: "CPF:", value: this.provider.listProviderBkp[i].document},
                ],
                providerId: this.provider.listProviderBkp[i].id
              })
            }
          }
        }
        else{
          for(let i = initial; i < end; i++){
            if(this.provider.listProviderBkp[i].typePerson == 0 || this.provider.listProviderBkp[i].typePerson == 2){
              this.provider.listProvider.push({
                subtitles: [
                  {key: "Nome Fantasia:", value: this.provider.listProviderFilter[i].fantasyName},
                  {key: "Razão Social:", value: this.provider.listProviderFilter[i].companyName},
                  {key: "CNPJ:", value: this.provider.listProviderFilter[i].document},
                ],
                providerId: this.provider.listProviderFilter[i].id
              })
            }
            else{
              this.provider.listProvider.push({
                subtitles: [
                  {key: "Nome:", value: this.provider.listProviderFilter[i].fantasyName},
                  {key: "Apelido:", value: this.provider.listProviderFilter[i].companyName},
                  {key: "CPF:", value: this.provider.listProviderFilter[i].document},
                ],
                providerId: this.provider.listProviderFilter[i].id
              })
            }
          }
        }
      },
      changeStatus(status){
        this.order.listStatusSelected = status;
      },
      changeSector(sector){
        this.order.sectorSelected = sector;
      },
      changeSectorForward(sector){
        this.forward.sectorSelected = sector;
      },
      async changeProduct(product){
        this.product.selected = product;

        this.product.productAllData = this.product.listProductsBkp.find(pro => {
          return pro.id == product.productId
        });

        let crudService = new CrudService();

        let resultFeatures = await crudService.get(`comboOrder/GetFeatures?productId=${product.productId}&canViewOrderValue=${this.canViewOrderValue}`, this.loginData.token);

        if(resultFeatures.status == 200){
          this.features = resultFeatures.data;
          this.featuresShow = resultFeatures.data.map(f => {
            return {
              id: f.id,
              title: f.title,
              father: null,
              selected: null
            }
          });
        }
        else if(resultFeatures.status == 401){
          localStorage.removeItem("loginData");
          this.$router.push({name: 'Login', params: {logout: true}});
        }
        else if(resultFeatures.status == 400){
          this.dialog.title = "Erro";
          this.dialog.message = resultFeatures.data[0];
          this.dialog.show = true;
        }
        else if(resultFeatures.status != 204){
          this.dialog.title = "Erro";
          this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
          this.dialog.show = true;
        }

        this.width = 0;
        this.height = 0;
        this.length = 0;
        this.quantity = 1;

        this.totalItem = parseFloat(product.subtitles[2].value);
        
        this.sheetProduct = false;
      },
      changeProvider(provider){
        this.order.providerSelected = provider;
        this.sheetProvider = false;
      },
      async changeClient(client){
        this.order.clientSelected = client;
        
        let crudService = new CrudService();

        let resultClientsDetail = await crudService.get(`comboOrder/GetDetailsClient/${client.clientId}`, this.loginData.token);

        if(resultClientsDetail.status == 200 || resultClientsDetail.status == 204){
          if(resultClientsDetail.data != null)
          {
            this.emailClient = resultClientsDetail.data.email;
            this.phoneClient = resultClientsDetail.data.phone;
            this.celClient = resultClientsDetail.data.cel;
            this.addressClient = resultClientsDetail.data.address;
          }
          else
          {
            this.emailClient = "";
            this.phoneClient = "";
            this.celClient = "";
            this.addressClient = "";
          }
        }
        else if(resultClientsDetail.status == 401){
          localStorage.removeItem("loginData");
          this.$router.push({name: 'Login', params: {logout: true}});
        }
        else if(resultClientsDetail.status == 400){
          this.dialog.title = "Erro";
          this.dialog.message = resultClientsDetail.data[0];
          this.dialog.show = true;
        }
        else if(resultClientsDetail.status != 204){
          this.dialog.title = "Erro";
          this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
          this.dialog.show = true;
        }

        this.sheetClient = false;
      },
      changeFilterProduct(){
        this.product.listProductsFilter = this.product.listProductsBkp.filter(obj => {
        if( (obj.internalCode != null && obj.internalCode.toLowerCase().includes(this.product.filter.toLowerCase())) ||
            (obj.name != null && obj.name.toLowerCase().includes(this.product.filter.toLowerCase()))
          ){
            return true;
          }
        });

        this.product.listProducts = [];

        this.paginationProduct.page = 1;
        this.paginationProduct.length = Math.ceil(this.product.listProductsFilter.length / 50);

        for(let i = 0; i < 50; i++){
          this.product.listProducts.push({
            subtitles: [
              {key: "Código Interno:", value: this.product.listProductsFilter[i].internalCode},
              {key: "Descrição:", value: this.product.listProductsFilter[i].name},
              {key: "Preço de Venda: R$", value: parseFloat(this.product.listProductsFilter[i].unitValue).toFixed(2), show: this.canViewOrderValue ? null : false},
            ],
            productId: this.product.listProductsFilter[i].id
          })    
        }
      },
      changeFilterClient(){
        this.client.listClientsFilter = this.client.listClientsBkp.filter(obj => {
        if( (obj.fantasyName != null && obj.fantasyName.toLowerCase().includes(this.client.filter.toLowerCase())) ||
            (obj.companyName != null && obj.companyName.toLowerCase().includes(this.client.filter.toLowerCase())) ||
            (obj.document != null && obj.document.toLowerCase().includes(this.client.filter.toLowerCase())) ||
            (obj.rgIE != null && obj.rgIE.toLowerCase().includes(this.client.filter.toLowerCase())) ||
            (obj.phone != null && obj.phone.toLowerCase().includes(this.client.filter.toLowerCase())) ||
            (obj.cellPhone != null && obj.cellPhone.toLowerCase().includes(this.client.filter.toLowerCase())) ||
            (obj.login != null && obj.login.toLowerCase().includes(this.client.filter.toLowerCase())) ||
            (obj.address != null && obj.address.replace(/\s+/g,' ').toLowerCase().includes(this.client.filter.toLowerCase()))
          ){
            return true;
          }
        });

        this.client.listClients = [];

        this.paginationClient.page = 1;
        this.paginationClient.length = Math.ceil(this.client.listClientsFilter.length / 50);

        for(let i = 0; i < 50; i++){
          if(this.client.listClientsFilter[i].typePerson == 0 || this.client.listClientsFilter[i].typePerson == 2){
            this.client.listClients.push({
              subtitles: [
                {key: "Nome Fantasia:", value: this.client.listClientsFilter[i].fantasyName},
                {key: "Razão Social:", value: this.client.listClientsFilter[i].companyName},
                {key: "CNPJ:", value: this.client.listClientsFilter[i].document},
              ],
              clientId: this.client.listClientsFilter[i].id
            })
          }
          else{
            this.client.listClients.push({
              subtitles: [
                {key: "Nome:", value: this.client.listClientsFilter[i].fantasyName},
                {key: "Apelido:", value: this.client.listClientsFilter[i].companyName},
                {key: "CPF:", value: this.client.listClientsFilter[i].document},
              ],
              clientId: this.client.listClientsFilter[i].id
            })
          }
        }
      },
      changeFilterProvider(){
        this.provider.listProviderFilter = this.provider.listProviderBkp.filter(obj => {
        if( (obj.fantasyName!= null && obj.fantasyName.toLowerCase().includes(this.provider.filter.toLowerCase())) ||
            (obj.companyName != null && obj.companyName.toLowerCase().includes(this.provider.filter.toLowerCase())) ||
            (obj.document != null && obj.document.toLowerCase().includes(this.provider.filter.toLowerCase()))
          ){
            return true;
          }
        });

        this.provider.listProvider = [];

        this.paginationProvider.page = 1;
        this.paginationProvider.length = Math.ceil(this.provider.listProviderFilter.length / 50);

        for(let i = 0; i < 50; i++){
          if(this.provider.listProviderFilter[i].typePerson == 0 || this.provider.listProviderFilter[i].typePerson == 2){
            this.provider.listProvider.push({
              subtitles: [
                {key: "Nome Fantasia:", value: this.provider.listProviderFilter[i].fantasyName},
                {key: "Razão Social:", value: this.provider.listProviderFilter[i].companyName},
                {key: "CNPJ:", value: this.provider.listProviderFilter[i].document},
              ],
              providerId: this.provider.listProviderFilter[i].id
            })
          }
          else{
            this.provider.listProvider.push({
              subtitles: [
                {key: "Nome:", value: this.provider.listProviderFilter[i].fantasyName},
                {key: "Apelido:", value: this.provider.listProviderFilter[i].companyName},
                {key: "CPF:", value: this.provider.listProviderFilter[i].document},
              ],
              providerId: this.provider.listProviderFilter[i].id
            })
          }
        }
      },
      loadCanView(){
        
        let canDeliveryDate = this.loginData.labels.find(permission => {
          return permission.typeLabel == 4
        });

        let canDeliveryHour = this.loginData.labels.find(permission => {
          return permission.typeLabel == 6
        });

        let canDeliveryPlace = this.loginData.labels.find(permission => {
          return permission.typeLabel == 8
        });

        let canTypeDeliverySelected = this.loginData.labels.find(permission => {
          return permission.typeLabel == 9
        });

        let canPaymentConditions = this.loginData.labels.find(permission => {
          return permission.typeLabel == 10
        });        

        let canInstallDate = this.loginData.labels.find(permission => {
          return permission.typeLabel == 13
        });

        let canInstallHour = this.loginData.labels.find(permission => {
          return permission.typeLabel == 14
        });

        let canQtdInstallers = this.loginData.labels.find(permission => {
          return permission.typeLabel == 15
        });

        let canInstallPlace = this.loginData.labels.find(permission => {
          return permission.typeLabel == 16
        });

        let canResponsibleName = this.loginData.labels.find(permission => {
          return permission.typeLabel == 18
        });

        let canResponsiblePhone = this.loginData.labels.find(permission => {
          return permission.typeLabel == 19
        });

        let canResponsibleEmail = this.loginData.labels.find(permission => {
          return permission.typeLabel == 20
        });

        let canWithdrawalDate = this.loginData.labels.find(permission => {
          return permission.typeLabel == 24
        });

        let canWithdrawalHour = this.loginData.labels.find(permission => {
          return permission.typeLabel == 25
        });
        
        let canPickupLocation = this.loginData.labels.find(permission => {
          return permission.typeLabel == 26
        });

        let canQtdInstallersWithdrawal = this.loginData.labels.find(permission => {
          return permission.typeLabel == 27
        });

        let canTypeDeliveryWithdrawalSelected = this.loginData.labels.find(permission => {
          return permission.typeLabel == 28
        });

        if(
          canTypeDeliveryWithdrawalSelected != null ||
          canQtdInstallersWithdrawal != null ||
          canPickupLocation != null ||
          canWithdrawalHour != null ||
          canWithdrawalDate != null ||
          canResponsibleEmail != null ||
          canResponsiblePhone != null ||
          canResponsibleName != null ||
          canInstallPlace != null ||
          canQtdInstallers != null ||
          canInstallHour != null ||
          canInstallDate != null ||
          canPaymentConditions != null ||
          canTypeDeliverySelected != null ||
          canDeliveryPlace != null ||
          canDeliveryHour != null ||
          canDeliveryDate != null
        ){
          this.showDates = true;
        }

        this.canView = {
          withdrawalDate: {
            show: canWithdrawalDate != null,
            text: canWithdrawalDate != null ? canWithdrawalDate.name : ""
          },
          withdrawalHour: {
            show: canWithdrawalHour != null,
            text: canWithdrawalHour != null ? canWithdrawalHour.name : ""
          },
          deliveryDate: {
            show: canDeliveryDate != null,
            text: canDeliveryDate != null ? canDeliveryDate.name : ""
          },
          deliveryHour: {
            show: canDeliveryHour != null,
            text: canDeliveryHour != null ? canDeliveryHour.name : ""
          },
          installDate: {
            show: canInstallDate != null,
            text: canInstallDate != null ? canInstallDate.name : ""
          },
          installHour: {
            show: canInstallHour != null,
            text: canInstallHour != null ? canInstallHour.name : ""
          },
          installPlace: {
            show: canInstallPlace != null,
            text: canInstallPlace != null ? canInstallPlace.name : ""
          },
          qtdInstallers: {
            show: canQtdInstallers != null,
            text: canQtdInstallers != null ? canQtdInstallers.name : ""
          },
          qtdInstallersWithdrawal: {
            show: canQtdInstallersWithdrawal != null,
            text: canQtdInstallersWithdrawal != null ? canQtdInstallersWithdrawal.name : ""
          },
          responsibleEmail: {
            show: canResponsibleEmail != null,
            text: canResponsibleEmail != null ? canResponsibleEmail.name : ""
          },
          responsibleName: {
            show: canResponsibleName != null,
            text: canResponsibleName != null ? canResponsibleName.name : ""
          },
          responsiblePhone: {
            show: canResponsiblePhone != null,
            text: canResponsiblePhone != null ? canResponsiblePhone.name : ""
          },
          paymentConditions: {
            show: canPaymentConditions != null,
            text: canPaymentConditions != null ? canPaymentConditions.name : ""
          },
          deliveryPlace: {
            show: canDeliveryPlace != null,
            text: canDeliveryPlace != null ? canDeliveryPlace.name : ""
          },
          pickupLocation: {
            show: canPickupLocation != null,
            text: canPickupLocation != null ? canPickupLocation.name : ""
          },
          typeDeliverySelected: {
            show: canTypeDeliverySelected != null,
            text: canTypeDeliverySelected != null ? canTypeDeliverySelected.name : ""
          },
          typeDeliveryWithdrawalSelected: {
            show: canTypeDeliveryWithdrawalSelected != null,
            text: canTypeDeliveryWithdrawalSelected != null ? canTypeDeliveryWithdrawalSelected.name : ""
          },
        }
      },
      removeItem(index){
        this.order.productsSelectedOrder.splice(index, 1);

        this.order.totalOrder = 0;

        this.order.productsSelectedOrder.forEach(prod => {
          this.order.totalOrder += prod.totalItem;
        });
      },
      async editItem(item, index){
        let loader = this.$loading.show();
        
        this.indexEdit = index;

        var productSelected = this.product.listProductsBkp.find(pro => {
          return pro.id == item.productId
        });
        
        await this.changeProduct({
          "productId": productSelected.id,
          "subtitles": [
            {"key": "Código Interno:", "value": productSelected.internalCode},
            {"key": "Descrição:", "value": productSelected.name},
            {"key": "Preço de Venda: R$", "value": productSelected.unitValue, "show": this.canViewOrderValue ? null : false}
          ]
        });

        this.name = item.obs1;
        this.additionItem = item.additionItem;
        this.discountItem = item.discountItem;
        this.quantity = item.quantity;
        this.width = item.width;
        this.height = item.height;
        this.length = item.length;
        
        this.featuresShow = item.features;
        this.dialogAddProduct = true;

        this.featuresShow.forEach(feature => {
          if(feature.selected != null)
            this.featuresValue += (feature.selected.value * (this.product.productAllData.taxedUnit == 6 ? this.height * this.width : this.product.productAllData.taxedUnit == 7 ? this.height * this.width * this.length : 1));
        });

        loader.hide();  
      },
      changeMeters(){
        this.featuresValue = 0;

        this.featuresShow.forEach(feature => {
          if(feature.selected != null)
            this.featuresValue += (feature.selected.value * (this.product.productAllData.taxedUnit == 6 ? this.height * this.width : this.product.productAllData.taxedUnit == 7 ? this.height * this.width * this.length : 1));
        });
      },
      async finishOrder(){   
        let loader = this.$loading.show();

        try
        {
          let newOrder = {
            clientId: this.order.clientSelected != null ? this.order.clientSelected.clientId : 0,
            providerId: this.order.providerSelected != null ? this.order.providerSelected.providerId : null,
            signatureId: this.loginData.userData.signatureId,
            statusId: this.order.listStatusSelected.value,
            total: this.order.totalOrder,
            issuanceDate: moment(this.order.createDate).format("YYYY-MM-DD"),
            addition: parseFloat(this.order.addition),
            discount: parseFloat(this.order.discount),
            responsibles: this.order.listResponsiblesSelected?.filter((val) => {return !isNaN(val)}),
            obsInReport: this.order.obsInReport,
            sectorId: this.order.sectorSelected != null ? this.order.sectorSelected.value : 0,
            showObsInReport: this.order.showNotesInReport,
            showSimpleReport: this.order.showSimpleReport,
            showAdditionInReport: this.order.hideInReport,
            deliveryHour: this.order.deliveryHour == "" ? null : this.order.deliveryHour,
            deliveryDate: this.order.deliveryDate == "" ? null : this.order.deliveryDate,
            paymentConditions: this.order.paymentConditions == "" ? null : this.order.paymentConditions, 
            descriptionInNF: this.order.descriptionInNF == "" ? null : this.order.descriptionInNF,
            creationUser: this.loginData.userData.userId,
            installDate: this.order.installDate == "" ? null : this.order.installDate,
            installHour: this.order.installHour == "" ? null : this.order.installHour,
            qtdInstallers: this.order.qtdInstallers.toString(),
            installPlace: this.order.installPlace == "" ? null : this.order.installPlace,
            deliveryPlace: this.order.deliveryPlace == "" ? null : this.order.deliveryPlace,
            typeDeliverySelected: this.order.typeDeliverySelected.toString(),
            responsibleName: this.order.responsibleName == "" ? null : this.order.responsibleName,
            responsiblePhone: this.order.responsiblePhone == "" ? null : this.order.responsiblePhone,
            responsibleEmail: this.order.responsibleEmail == "" ? null : this.order.responsibleEmail,
            withdrawalDate: this.order.withdrawalDate == "" ? null : this.order.withdrawalDate,
            withdrawalHour: this.order.withdrawalHour == "" ? null : this.order.withdrawalHour,
            pickupLocation: this.order.pickupLocation == "" ? null : this.order.pickupLocation,
            qtdInstallersWithdrawal: this.order.qtdInstallersWithdrawal.toString(),
            typeDeliveryWithdrawalSelected: this.order.typeDeliveryWithdrawalSelected.toString(),
            productsSelectedOrder: this.order.productsSelectedOrder,
            label: this.labelDepartment
          }

          let data = new FormData();
          data.append('Request', JSON.stringify(newOrder));
          data.append('MaxUpload', this.loginData.maxUpload);
      
          this.order.files.forEach((file) => {
            data.append('Files', file);
          });
          
          let crudService = new CrudService();

          let result = await crudService.postWithFile(`order`, data, this.loginData.token);

          if(result.status == 200){
            this.dialog.title = "Sucesso";
            this.dialog.message = `${this.labelOrder} criado com sucesso.`;
            this.dialog.show = true;

            this.disabled0 = false;
            this.disabled1 = false;
            this.disabled2 = false;
            this.value = 0;
            this.showBtn = false;
            this.order.code = result.data.code;
            localStorage.setItem("orderId", result.data.orderId);
            this.orderId = result.data.orderId;
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data[0];
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();   
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;   
        }
      },
      async downloadFile(file){
        let loader = this.$loading.show();

        try
        {
          let crudService = new CrudService();
          
          let result = await crudService.get(`attachments/fileExistsOrder?path=${file.path}`, this.loginData.token);

          if(result.status == 200){
            let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1; 
            let safariAgent = navigator.userAgent.indexOf("Safari") > -1;

            if (chromeAgent && safariAgent){
              await crudService.downloadFile(`attachments?path=${result.data}`, file.fileName, this.loginData.token);
            }
            else{
              this.dialogAction = true;
              this.linkDownloadFile = `https://sig.plataformasig.com.br/sig/api/attachments?path=${result.data}`;
            }
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data;
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;
        }
      },
      copyText () {
        let textToCopy = this.$refs.textToCopy.$el.querySelector('input')
        textToCopy.select()
        document.execCommand("copy");
      },
      async updateOrder(){
        let loader = this.$loading.show();

        try
        {
          let attachmentsExistents = "";
          this.order.files.forEach(f => {
            if(f.path != null && f.path != ''){
              attachmentsExistents += `${f.path}|`
            }
          });

          attachmentsExistents = attachmentsExistents.slice(0, -1);

          let updateOrder = {
            attachments: attachmentsExistents,
            orderId: this.orderId,
            code: this.order.code,
            clientId: this.order.clientSelected != null ? this.order.clientSelected.clientId : 0,
            providerId: this.order.providerSelected != null ? this.order.providerSelected.providerId : null,
            signatureId: this.loginData.userData.signatureId,
            statusId: this.order.listStatusSelected.value,
            total: this.order.totalOrder,
            issuanceDate: moment(this.order.createDate).format("YYYY-MM-DD"),
            addition: parseFloat(this.order.addition),
            discount: parseFloat(this.order.discount),
            responsibles: this.order.listResponsiblesSelected?.filter((val) => {return !isNaN(val)}),
            obsInReport: this.order.obsInReport,
            sectorId: this.order.sectorSelected != null ? this.order.sectorSelected.value : 0,
            showObsInReport: this.order.showNotesInReport,
            showSimpleReport: this.order.showSimpleReport,
            showAdditionInReport: this.order.hideInReport,
            deliveryHour: this.order.deliveryHour == "" ? null : this.order.deliveryHour,
            deliveryDate: this.order.deliveryDate == "" ? null : this.order.deliveryDate,
            paymentConditions: this.order.paymentConditions == "" ? null : this.order.paymentConditions, 
            descriptionInNF: this.order.descriptionInNF == "" ? null : this.order.descriptionInNF,
            creationUser: this.loginData.userData.userId,
            installDate: this.order.installDate == "" ? null : this.order.installDate,
            installHour: this.order.installHour == "" ? null : this.order.installHour,
            qtdInstallers: this.order.qtdInstallers.toString(),
            installPlace: this.order.installPlace == "" ? null : this.order.installPlace,
            deliveryPlace: this.order.deliveryPlace == "" ? null : this.order.deliveryPlace,
            typeDeliverySelected: this.order.typeDeliverySelected.toString(),
            responsibleName: this.order.responsibleName == "" ? null : this.order.responsibleName,
            responsiblePhone: this.order.responsiblePhone == "" ? null : this.order.responsiblePhone,
            responsibleEmail: this.order.responsibleEmail == "" ? null : this.order.responsibleEmail,
            withdrawalDate: this.order.withdrawalDate == "" ? null : this.order.withdrawalDate,
            withdrawalHour: this.order.withdrawalHour == "" ? null : this.order.withdrawalHour,
            pickupLocation: this.order.pickupLocation == "" ? null : this.order.pickupLocation,
            qtdInstallersWithdrawal: this.order.qtdInstallersWithdrawal.toString(),
            typeDeliveryWithdrawalSelected: this.order.typeDeliveryWithdrawalSelected.toString(),
            productsSelectedOrder: this.order.productsSelectedOrder,
            label: this.labelDepartment
          }

          let data = new FormData();
          data.append('Request', JSON.stringify(updateOrder));
          data.append('MaxUpload', this.loginData.maxUpload);

          this.order.files.forEach((file) => {
            data.append('Files', file);
          });
          
          let crudService = new CrudService();

          let result = await crudService.patchWithFile(`order/${this.orderId}`, data, this.loginData.token);

          if(result.status == 200){
            this.dialog.title = "Sucesso";
            this.dialog.message = `${this.labelOrder} alterado com sucesso.`;
            this.dialog.show = true;
            
            this.clickOption({go: ""});
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data[0];
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();   
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;   
        }
      },
      goHistory(){
        this.value = 3;
        window.setTimeout(() => {
          window.scrollTo(0,document.body.scrollHeight)
        }, 0);

        this.options = this.options.filter(o => {
          return o.go != "addItem"
        });
      },
      changeMenu(id){
        this.value = id;

        if(id == 2 && !this.disabledOrder){
          this.options.push({ icon: 'mdi-cart-plus', title: `Adicionar Item`, go: "addItem" });
        }
        else{
          this.options = this.options.filter(o => {
            return o.go != "addItem"
          });
        }
      },
      scanItem(){
        let data = {
          dialogRemoveAttachment: this.dialogRemoveAttachment,
          component: this.component,
          sheetOptions: this.sheetOptions,
          options: this.options,
          disabledOrder: this.disabledOrder,
          editEnable: this.editEnable,
          canEdit: this.canEdit,
          canDelete: this.canDelete,
          canRemoveAttachment: this.canRemoveAttachment,
          value: this.value,
          orderId: this.orderId,
          loginData: this.loginData,
          title: this.title,
          listStatus: this.listStatus,
          listSector: this.listSector,
          labelDepartment: this.labelDepartment,
          createDate: this.createDate,
          emailClient: this.emailClient,
          phoneClient: this.phoneClient,
          celClient: this.celClient,
          addressClient: this.addressClient,
          sheetClient: this.sheetClient,
          sheetProvider: this.sheetProvider,
          sheetProduct: this.sheetProduct,
          client: this.client,
          provider: this.provider,
          product: this.product,
          paginationClient: this.paginationClient,
          paginationProvider: this.paginationProvider,
          paginationProduct: this.paginationProduct,
          listResponsibles: this.listResponsibles,
          disabled0: this.disabled0,
          disabled1: this.disabled1,
          disabled2: this.disabled2,
          showDates: this.showDates,
          withdrawalDate: this.withdrawalDate,
          deliveryDate: this.deliveryDate,
          installDate: this.installDate,
          typeDelivery: this.typeDelivery,
          dialogFeature: this.dialogFeature,
          dialogEdit: this.dialogEdit,
          dialogAddProduct: this.dialogAddProduct,
          featureSelected: this.featureSelected,
          featureSelectedRadio: this.featureSelectedRadio,
          listRadio: this.listRadio,
          width: this.width,
          height: this.height,
          length: this.length,
          quantity: this.quantity,
          totalItem: this.totalItem,
          name: this.name,
          additionItem: this.additionItem,
          discountItem: this.discountItem,
          featuresShow: this.featuresShow,
          features: this.features,
          dialog: this.dialog,
          dialogForward: this.dialogForward,
          dialogConfirm: this.dialogConfirm,
          canView: this.canView,
          forward: this.forward,
          order: this.order,
          featuresValue: this.featuresValue,
          arrayRemove: this.arrayRemove,
          indexEdit: this.indexEdit,
          canViewOrderValue: this.canViewOrderValue,
          showBtn: this.showBtn,
          labelOrder: this.labelOrder,
          dialogAction: this.dialogAction,
          linkDownloadFile: this.linkDownloadFile,
          history: this.history,
          historyDelete: this.historyDelete,
          historyEdit: this.historyEdit,
          iconInfo: this.iconInfo,
          index: this.index
        }
        this.$router.push({name: 'QrCodeOrder', params: {data: data}});
      },
      onLongPressStartEdit(history){
        this.dialogEdit = true;
        this.historyEdit.id = history.id;
        this.historyEdit.text = history.text.replace('Comentário: ','');
      },
      onLongPressStartDelete(history){
        this.historyDelete = history;
        this.dialogConfirm = true;
      },
      enableEdit(){
        this.editEnable = true;
        this.disabledOrder = false;
      },
      async confirmDelete(){
        this.dialogConfirm = false;
        let loader = this.$loading.show();

        try
        {
          let crudService = new CrudService();
        
          let resultDelete = await crudService.delete(`order/deleteHistory/${this.historyDelete.id}`, this.loginData.token);
          
          if(resultDelete.status == 200){
            this.history = this.history.filter(h => {
              return h.id != this.historyDelete.id;
            });

            this.dialog.title = "Sucesso";
            this.dialog.message = "Removido com sucesso.";
            this.dialog.show = true; 
          }
          else if(resultDelete.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultDelete.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultDelete.data[0];
            this.dialog.show = true;
          }
          else if(resultDelete.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();   
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;   
        }
      },
      async updateHistory(){
        let loader = this.$loading.show();

        try
        {
          let crudService = new CrudService();

          let request = {
            historyId: this.historyEdit.id,
            text: `Comentário: ${this.historyEdit.text}`
          };
        
          let resultUpdate = await crudService.patch(`order/updateHistory/${this.historyEdit.id}`, request, this.loginData.token);
          
          if(resultUpdate.status == 200){
            this.history = this.history.map(h => {
              if(h.id == this.historyEdit.id){
                h.text = `Comentário: ${this.historyEdit.text}`
              }

              return h;
            });

            this.dialogEdit = false;

            this.dialog.title = "Sucesso";
            this.dialog.message = "Alterado com sucesso.";
            this.dialog.show = true;  
          }
          else if(resultUpdate.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultUpdate.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultUpdate.data[0];
            this.dialog.show = true;
          }
          else if(resultUpdate.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();   
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;   
        }
      },
      removeAttachment(index){
        this.index = index;
        this.dialogRemoveAttachment = true;
      },
      cancelRemoveAttachment(){
        this.index = -1;
        this.dialogRemoveAttachment = false;
      },
      async confirmRemoveAttachment(){
        this.order.files.splice(this.index, 1);
        this.index = -1;
        this.dialogRemoveAttachment = false;
        await this.updateOrder();
      },
      changeFile(files){
        this.order.files = [...this.order.files, ...files];
      },
      async forwardOrder(){
        let loader = this.$loading.show();

        let listSend = this.forward.listResponsiblesSelected.map(l => {
          let result = this.listResponsibles.find(r => {
            return r.value == l
          });

          return {
            responsibleId: result.value,
            name: result.text
          }
        });

        let approvalOfStockEntry = this.loginData.permissionAndMenu.find((men) => {
          return men.menuId == 232
        });

        let approvalOfStockExit = this.loginData.permissionAndMenu.find((men) => {
          return men.menuId == 236
        });

        try
        {
          let crudService = new CrudService();

          let request = {
            responsibles: listSend?.filter((val) => {return !isNaN(val.responsibleId)}),
            orderId: this.orderId,
            userId: this.loginData.userData.userId,
            text: this.forward.text,
            userName: this.loginData.userData.name,
            labelSectorSelected: this.forward.sectorSelected.text,
            labelSector: this.labelDepartment,
            sectorId: this.forward.sectorSelected.value,
            signatureId: this.loginData.userData.signatureId,
            code: this.order.code,
            stockManager: this.loginData.stockManager,
            stockManagerEmail: this.loginData.stockManagerEmail,
            approvalOfStockEntry: approvalOfStockEntry != null,
            approvalOfStockExit: approvalOfStockExit != null
          };
          
          let result = await crudService.patch(`order/forwardOrder/${this.orderId}`, request, this.loginData.token);
          
          if(result.status == 200){
            await this.getOrder();

            this.closeDialogForwardOrder();

            this.dialog.title = "Sucesso";
            this.dialog.message = "Encaminhado com sucesso.";
            this.dialog.show = true;  
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data[0];
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          loader.hide();  
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;   
        }
      },
      closeDialogForwardOrder(){
        this.forward.sectorSelected = null;
        this.forward.listResponsiblesSelected = [];
        this.forward.text = "";
        this.dialogForward = false;
      },
      async openListClients(){
        this.sheetClient = true;
        let loader = this.$loading.show();
        await this.getClientAsync(null);
        loader.hide();
      },
      async getClientAsync(getOrder){

        if(this.client.listClientsBkp.length == 0){
          let crudService = new CrudService();
          let resultClients = await crudService.get(`comboOrder/GetComboClientsDetail?signatureId=${this.loginData.userData.signatureId}&personId=${this.loginData.userData.personId}`, this.loginData.token);
  
          if(resultClients.status == 200){
            this.client.listClientsBkp = resultClients.data;
            this.paginationClient.length = Math.ceil(resultClients.data.length / 50);
            
            for(let i = 0; i < (resultClients.data.length > 50 ? 50 : resultClients.data.length); i++){
              if(resultClients.data[i].typePerson == 0 || resultClients.data[i].typePerson == 2){
                this.client.listClients.push({
                  subtitles: [
                    {key: "Nome Fantasia:", value: resultClients.data[i].fantasyName},
                    {key: "Razão Social:", value: resultClients.data[i].companyName},
                    {key: "CNPJ:", value: resultClients.data[i].document},
                  ],
                  clientId: resultClients.data[i].id
                })
              }
              else{
                this.client.listClients.push({
                  subtitles: [
                    {key: "Nome:", value: resultClients.data[i].fantasyName},
                    {key: "Apelido:", value: resultClients.data[i].companyName},
                    {key: "CPF:", value: resultClients.data[i].document},
                  ],
                  clientId: resultClients.data[i].id
                })
              }
            }
          }
          else if(resultClients.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultClients.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultClients.data[0];
            this.dialog.show = true;
          }
          else if(resultClients.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }
  
          if(getOrder != null){
            let clientAllData = this.client.listClientsBkp.find(c => {
              return c.id == getOrder.data.client
            });
    
            if(clientAllData != null){
              if(clientAllData.typePerson == 2){
                await this.changeClient({
                  "clientId": getOrder.data.client,
                  "subtitles": [
                    {"key": "Nome Fantasia:", "value": clientAllData.fantasyName},
                    {"key": "Razão Social:", "value": clientAllData.companyName},
                    {"key": "CNPJ:", "value": clientAllData.document}
                  ]
                });
              }
              else{
                await this.changeClient({
                  "clientId": getOrder.data.client,
                  "subtitles": [
                    {"key": "Nome:", "value": clientAllData.fantasyName},
                    {"key": "Apelido:", "value": clientAllData.companyName},
                    {"key": "CPF:", "value": clientAllData.document}
                  ]
                });
              }
            }
          }
        }
      },
      async getOrder(){
        let crudService = new CrudService();
        let getOrder = await crudService.get(`order/${this.orderId}`, this.loginData.token);

        if(getOrder.status == 200){
          this.getClientAsync(getOrder);

          this.order.productsSelectedOrder = getOrder.data.productsSelectedOrder;
          this.order.code = getOrder.data.code;
          this.order.createDate = moment(new Date(getOrder.data.createDate)).format("YYYY-MM-DD");
          this.order.showSimpleReport = getOrder.data.showSimpleReport;
          this.order.hideInReport = getOrder.data.hideInReport;
          this.order.showNotesInReport = getOrder.data.showNotesInReport;
          this.order.obsInReport = getOrder.data.obsInReport;
          this.order.descriptionInNF = getOrder.data.descriptionInNF;
          
          if(getOrder.data.files != null && getOrder.data.files != "")
          {
            let arrFiles = getOrder.data.files.split('|');
            this.order.files = arrFiles.map((f, index) => {
              let fileName = f.split("/");
              
              return {
                attachmentId: index,
                fileName: fileName[fileName.length - 1],
                path: f
              }
            });
          }

          this.order.listStatusSelected = this.listStatus.items.find(i => {
            return i.value == getOrder.data.status
          });
          this.order.sectorSelected = this.listSector.items.find(i => {
            return i.value == getOrder.data.sector
          });
          
          if(getOrder.data.provider != 0){
            let providerAllData = this.provider.listProviderBkp.find(p => {
              return p.id == getOrder.data.provider
            });

            if(providerAllData != null){
              if(providerAllData.typePerson == 2){
                await this.changeProvider({
                  "providerId": getOrder.data.provider,
                  "subtitles": [
                    {"key": "Nome Fantasia:", "value": providerAllData.fantasyName},
                    {"key": "Razão Social:", "value": providerAllData.companyName},
                    {"key": "CNPJ:", "value": providerAllData.document}
                  ]
                });
              }
              else{
                await this.changeProvider({
                  "providerId": getOrder.data.provider,
                  "subtitles": [
                    {"key": "Nome:", "value": providerAllData.fantasyName},
                    {"key": "Apelido:", "value": providerAllData.companyName},
                    {"key": "CPF:", "value": providerAllData.document}
                  ]
                });
              }
            }
          }

          let arrResponsibles = getOrder.data.listResponsiblesSelected.split(',');
          arrResponsibles.forEach(r => {
            let withoutSpaces = r.trim();
            let id = withoutSpaces.substring(1);
            id = id.substring(0, withoutSpaces.length - 1);

            let idInt = parseInt(id);

            let find = this.order.listResponsiblesSelected.find(r => {
              return r == idInt
            });

            if(find == null)
              this.order.listResponsiblesSelected.push(idInt);
          });

          this.order.deliveryDate = getOrder.data.deliveryDate != null ? getOrder.data.deliveryDate.split('T')[0] : "";
          this.order.deliveryHour = getOrder.data.deliveryHour;
          this.order.deliveryPlace = getOrder.data.deliveryPlace;
          this.order.installDate = getOrder.data.installDate != null ? getOrder.data.installDate.split('T')[0] : "";
          this.order.installHour = getOrder.data.installHour;
          this.order.installPlace = getOrder.data.installPlace;
          this.order.paymentConditions = getOrder.data.paymentConditions;
          this.order.pickupLocation = getOrder.data.pickupLocation;
          this.order.qtdInstallers = getOrder.data.qtdInstallers;
          this.order.qtdInstallersWithdrawal = getOrder.data.qtdInstallersWithdrawal;
          this.order.responsibleEmail = getOrder.data.responsibleEmail;
          this.order.responsibleName = getOrder.data.responsibleName;
          this.order.responsiblePhone = getOrder.data.responsiblePhone;
          this.order.typeDelivery = getOrder.data.typeDelivery;
          this.order.typeDeliveryWithdrawal = getOrder.data.typeDeliveryWithdrawal;
          this.order.withdrawalDate = getOrder.data.withdrawalDate != null ? getOrder.data.withdrawalDate.split('T')[0] : "";
          this.order.withdrawalHour = getOrder.data.withdrawalHour;
          this.order.addition = getOrder.data.addition;
          this.order.discount = getOrder.data.discount;
          this.order.totalOrder = getOrder.data.totalOrder - (getOrder.data.addition - getOrder.data.discount);
          
          let inverse = getOrder.data.history.slice().reverse();
          
          this.history = inverse.map(h => {
            let textInteraction = "";
            let initials = "";
            let arrInitials = h.name.split(" ");

            if(arrInitials.length >= 2)
              initials = `${arrInitials[0].substr(0,1).toUpperCase()}${arrInitials[1].substr(0,1).toUpperCase()}`;
            else if(arrInitials.length == 1)
              initials = arrInitials[0].substr(0,2).toUpperCase();

            textInteraction = h.text.split("\n").join("<br />");
            
            return {
              id: h.id,
              text: textInteraction,
              name: h.name,
              initials,
              date: moment(h.date).format("DD/MM/YYYY HH:mm"),
              email: h.email
            }
          });

          this.disabled0 = false;
          this.disabled1 = false;
          this.disabled2 = false;
          this.value = 0;
          this.showBtn = false;
        }
        else if(getOrder.status == 401){
          localStorage.removeItem("loginData");
          this.$router.push({name: 'Login', params: {logout: true}});
        }
        else if(getOrder.status == 400){
          this.dialog.title = "Erro";
          this.dialog.message = getOrder.data[0];
          this.dialog.show = true;
        }
        else if(getOrder.status != 204){
          this.dialog.title = "Erro";
          this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
          this.dialog.show = true;
        }

        this.canDelete = this.loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 210;
        });

        if(!this.canDelete)
          this.canDelete = this.loginData.userData.isAdmin;

        this.canEdit = this.loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 209;
        });

        if(!this.canEdit)
          this.canEdit = this.loginData.userData.isAdmin;

        this.canRemoveAttachment = this.loginData.permissionAndMenu.find(permission => {
          return permission.menuId == 213;
        });

        if(!this.canRemoveAttachment)
          this.canRemoveAttachment = this.loginData.userData.isAdmin;
      }
    },

    async created(){
      let loader = this.$loading.show();

      let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1; 
      let safariAgent = navigator.userAgent.indexOf("Safari") > -1; 
      
      if (chromeAgent && safariAgent){
        this.showQrCode = true;
      }
      else{
        this.showQrCode = false;
      }

      if(this.$route.params.data != null)
      {
        let data = this.$route.params.data;

        this.dialogRemoveAttachment = data.dialogRemoveAttachment;
        this.component = data.component;
        this.sheetOptions = data.sheetOptions;
        this.options = data.options;
        this.disabledOrder = data.disabledOrder;
        this.editEnable = data.editEnable;
        this.canEdit = data.canEdit;
        this.canDelete = data.canDelete;
        this.canRemoveAttachment = data.canRemoveAttachment;
        this.value = data.value;
        this.orderId = data.orderId;
        this.loginData = data.loginData;
        this.title = data.title;
        this.listStatus = data.listStatus;
        this.listSector = data.listSector;
        this.labelDepartment = data.labelDepartment;
        this.createDate = data.createDate;
        this.emailClient = data.emailClient;
        this.phoneClient = data.phoneClient;
        this.celClient = data.celClient;
        this.addressClient = data.addressClient;
        this.sheetClient = data.sheetClient;
        this.sheetProvider = data.sheetProvider;
        this.sheetProduct = data.sheetProduct;
        this.client = data.client;
        this.provider = data.provider;
        this.product = data.product;
        this.paginationClient = data.paginationClient;
        this.paginationProvider = data.paginationProvider;
        this.paginationProduct = data.paginationProduct;
        this.listResponsibles = data.listResponsibles;
        this.disabled0 = data.disabled0;
        this.disabled1 = data.disabled1;
        this.disabled2 = data.disabled2;
        this.showDates = data.showDates;
        this.withdrawalDate = data.withdrawalDate;
        this.deliveryDate = data.deliveryDate;
        this.installDate = data.installDate;
        this.typeDelivery = data.typeDelivery;
        this.dialogFeature = data.dialogFeature;
        this.dialogEdit = data.dialogEdit;
        this.dialogAddProduct = data.dialogAddProduct;
        this.featureSelected = data.featureSelected;
        this.featureSelectedRadio = data.featureSelectedRadio;
        this.listRadio = data.listRadio;
        this.width = data.width;
        this.height = data.height;
        this.length = data.length;
        this.quantity = data.quantity;
        this.totalItem = data.totalItem;
        this.name = data.name;
        this.additionItem = data.additionItem;
        this.discountItem = data.discountItem;
        this.featuresShow = data.featuresShow;
        this.features = data.features;
        this.dialog = data.dialog;
        this.dialogForward = data.dialogForward;
        this.dialogConfirm = data.dialogConfirm;
        this.canView = data.canView;
        this.forward = data.forward;
        this.order = data.order;
        this.featuresValue = data.featuresValue;
        this.arrayRemove = data.arrayRemove;
        this.indexEdit = data.indexEdit;
        this.canViewOrderValue = data.canViewOrderValue;
        this.showBtn = data.showBtn;
        this.labelOrder = data.labelOrder;
        this.dialogAction = data.dialogAction;
        this.linkDownloadFile = data.linkDownloadFile;
        this.history = data.history;
        this.historyDelete = data.historyDelete;
        this.historyEdit = data.historyEdit;
        this.iconInfo = data.iconInfo;
        this.index = data.index;

        let crudService = new CrudService();

        try
        {
          let result = await crudService.get(`pdv/getProduct?signatureId=${this.loginData.userData.signatureId}&internalCode=${this.$route.params.productId}`, this.loginData.token);
          
          if(result.status == 200){
            this.changeProduct({
              subtitles: [
                {key: "Código Interno:", value: result.data.internalCode},
                {key: "Descrição:", value: result.data.name},
                {key: "Preço de Venda: R$", value: parseFloat(result.data.unitValue).toFixed(2)},
              ],
              productId: result.data.id
            });   
          }
          else if(result.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(result.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = result.data[0];
            this.dialog.show = true;
          }
          else if(result.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;
        }

        loader.hide();
      }
      else
      {
        let chromeAgent = navigator.userAgent.indexOf("Chrome") > -1; 
        let safariAgent = navigator.userAgent.indexOf("Safari") > -1;

        if (chromeAgent && safariAgent){
          this.iconInfo = "margin-left: 170px; position: absolute;";
        }
        else{
          this.iconInfo = "margin-left: 85px; position: absolute;";
        }

        try
        {
          this.loginData = JSON.parse(localStorage.getItem("loginData"));

          this.canViewOrderValue = this.loginData.userData.canViewOrderValue;
          
          let canOrder = this.loginData.permissionAndMenu.find(permission => {
            return permission.menuId == 216
          });

          if(canOrder == null)
            this.$router.push('menu');
          else{
            this.orderId = localStorage.getItem("orderId");

            this.loadCanView();
            
            let label = this.loginData.labels.find((lbl) => {
              return lbl.typeLabel == 17
            });

            this.labelOrder = label.name != null ? label.name : "Pedido";
            
            this.title = this.orderId != null && this.orderId != 0 ? "Detalhes" : `Novo ${this.labelOrder}`; 
          }

          let menu = this.loginData.permissionAndMenu.find((men) => {
            return men.menuId == 188
          });
          
          if(menu != null)
            this.labelDepartment = menu.name;
          else
            this.labelDepartment = "Setor";

          let crudService = new CrudService();
          
          this.order.listResponsiblesSelected.push(this.loginData.userData.operatorId);
          
          let resultProducts = await crudService.get(`comboOrder/GetComboProduct?signatureId=${this.loginData.userData.signatureId}&ProductsDemands=${this.loginData.productsDemands == null ? false : this.loginData.productsDemands}`, this.loginData.token);
          
          if(resultProducts.status == 200){
            this.product.listProductsBkp = resultProducts.data;
            this.paginationProduct.length = Math.ceil(resultProducts.data.length / 50);
            
            for(let i = 0; i < (resultProducts.data.length > 50 ? 50 : resultProducts.data.length); i++){
              this.product.listProducts.push({
                subtitles: [
                  {key: "Código Interno:", value: resultProducts.data[i].internalCode},
                  {key: "Descrição:", value: resultProducts.data[i].name},
                  {key: "Preço de Venda: R$", value: parseFloat(resultProducts.data[i].unitValue).toFixed(2), show: this.canViewOrderValue ? null : false},
                ],
                productId: resultProducts.data[i].id
              })
            }
          }
          else if(resultProducts.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultProducts.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultProducts.data[0];
            this.dialog.show = true;
          }
          else if(resultProducts.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          let resultStatus = await crudService.get(`comboOrder/getComboStatus/${this.loginData.userData.signatureId}`, this.loginData.token);
                    
          if(resultStatus.status == 200){
            this.listSector.items = [
              ...resultStatus.data.map(status => {
                return {
                  text: status.name,
                  value: status.statusId
                }
              })
            ]
          }
          else if(resultStatus.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultStatus.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultStatus.data[0];
            this.dialog.show = true;
          }
          else if(resultStatus.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          let resultProvider = await crudService.get(`comboOrder/GetComboProvider/${this.loginData.userData.signatureId}`, this.loginData.token);

          if(resultProvider.status == 200){
            this.provider.listProviderBkp = resultProvider.data;
            this.paginationProvider.length = Math.ceil(resultProvider.data.length / 50);
            
            for(let i = 0; i < (resultProvider.data.length > 50 ? 50 : resultProvider.data.length); i++){
              if(resultProvider.data[i].typePerson == 0 || resultProvider.data[i].typePerson == 2){
                this.provider.listProvider.push({
                  subtitles: [
                    {key: "Nome Fantasia:", value: resultProvider.data[i].fantasyName},
                    {key: "Razão Social:", value: resultProvider.data[i].companyName},
                    {key: "CNPJ:", value: resultProvider.data[i].document},
                  ],
                  providerId: resultProvider.data[i].id
                })
              }
              else{
                this.provider.listProvider.push({
                  subtitles: [
                    {key: "Nome:", value: resultProvider.data[i].fantasyName},
                    {key: "Apelido:", value: resultProvider.data[i].companyName},
                    {key: "CPF:", value: resultProvider.data[i].document},
                  ],
                  providerId: resultProvider.data[i].id
                })
              }
            }
          }
          else if(resultProvider.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultProvider.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultProvider.data[0];
            this.dialog.show = true;
          }
          else if(resultProvider.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          let resultOperators = await crudService.get(`comboOrder/GetComboResponsible/${this.loginData.userData.signatureId}`, this.loginData.token);
                
          if(resultOperators.status == 200){
            this.listResponsibles = [
              ...resultOperators.data.map(operator => {
                return {
                  text: operator.name,
                  value: operator.id,
                  disable: operator.id == this.loginData.userData.operatorId
                }
              })
            ]
          }
          else if(resultOperators.status == 401){
            localStorage.removeItem("loginData");
            this.$router.push({name: 'Login', params: {logout: true}});
          }
          else if(resultOperators.status == 400){
            this.dialog.title = "Erro";
            this.dialog.message = resultOperators.data[0];
            this.dialog.show = true;
          }
          else if(resultOperators.status != 204){
            this.dialog.title = "Erro";
            this.dialog.message = "Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.";
            this.dialog.show = true;
          }

          if(this.orderId != null && this.orderId != 0){
            await this.getOrder();
            this.disabledOrder = true;

            let canEditOrder = this.loginData.permissionAndMenu.find(p => {
              return p.menuId == 223
            })

            if(canEditOrder != null)
              this.options.push({ icon: 'mdi-lock-open', title: `Habilitar Edição`, go: "editEnable" });
          }

          loader.hide();
        }
        catch
        {
          loader.hide();
          this.dialog.title = "Erro";
          this.dialog.message = "Não foi possível conectar. Por favor, verifique sua conexão com a internet e tente novamente mais tarde.";
          this.dialog.show = true;
        }  
      } 
    },

    beforeDestroy(){
      localStorage.removeItem("orderId");
    }
  }
</script>
<style scoped>
.col-sm-6 {
  padding: 0px;
  padding-right: 12px;
  padding-left: 12px;
}
.col-sm-12 {
  padding: 0px;
  padding-right: 12px;
  padding-left: 12px;
}
.btnPlus {
  margin-bottom:130px;
  margin-left:10px; 
  margin-right:-10px;
}
.bottomNavigation{
  margin-bottom: 60px;
}
.bottomNavigation0{
  margin-bottom: 40px;
}
.bottomNavigation1{
  margin-bottom: 40px;
}
.btnForward{
  margin-bottom:50px;
}
/* iphone X , XS, 11 Pro, 12 Mini */
@media only screen and (min-width: 375px) and (max-height: 812px) and (-webkit-device-pixel-ratio: 3) { 
  .btnPlus {
    margin-bottom:155px;
    margin-left:10px; 
    margin-right:-10px;
  }
  .btnForward{
    margin-bottom:80px;
  }
  .bottomNavigation{
    margin-bottom: 80px;
  }
  .bottomNavigation0{
    margin-bottom: 60px;
  }
  .bottomNavigation1{
    margin-bottom: 40px;
  }
}

/* iphone 12, 12 Pro */
@media only screen and (min-width: 390px) and (max-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .btnPlus {
    margin-bottom:155px;
    margin-left:10px; 
    margin-right:-10px;
  }
  .btnForward{
    margin-bottom:80px;
  }
  .bottomNavigation{
    margin-bottom: 80px;
  }
  .bottomNavigation0{
    margin-bottom: 60px;
  }
  .bottomNavigation1{
    margin-bottom: 40px;
  }
}

/* iphone XR, 11 */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 2) { 
  .btnPlus {
    margin-bottom:155px;
    margin-left:10px; 
    margin-right:-10px;
  }
  .btnForward{
    margin-bottom:80px;
  }
  .bottomNavigation{
    margin-bottom: 80px;
  }
  .bottomNavigation0{
    margin-bottom: 60px;
  }
  .bottomNavigation1{
    margin-bottom: 40px;
  }
}
    
/* iphone XS Max, 11 Pro Max */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 3) { 
  .btnPlus {
    margin-bottom:155px;
    margin-left:10px; 
    margin-right:-10px;
  }
  .btnForward{
    margin-bottom:80px;
  }
  .bottomNavigation{
    margin-bottom: 80px;
  }
  .bottomNavigation0{
    margin-bottom: 60px;
  }
  .bottomNavigation1{
    margin-bottom: 40px;
  }
}

/* iphone 12 Pro Max */
@media only screen and (min-width : 428px) and (max-height : 926px) and (-webkit-device-pixel-ratio : 3) { 
  .btnPlus {
    margin-bottom:155px;
    margin-left:10px; 
    margin-right:-10px;
  }
  .btnForward{
    margin-bottom:80px;
  }
  .bottomNavigation{
    margin-bottom: 80px;
  }
  .bottomNavigation0{
    margin-bottom: 60px;
  }
  .bottomNavigation1{
    margin-bottom: 40px;
  }
}
</style>
<style>
.files {
  display: flex;
  overflow-x: auto;
  margin-left: 10px;
  margin-right: 10px;
}
.files::-webkit-scrollbar {
  display: none;
}
.v-expansion-panel-content__wrap {
  padding: 20px 0px 20px 0px !important;
}
.totalOrder {
  margin-bottom:15px; 
  background-color:white !important;
}
/* iphone X , XS, 11 Pro, 12 Mini */
@media only screen and (min-width: 375px) and (max-height: 812px) and (-webkit-device-pixel-ratio: 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
  .totalOrder {
    margin-bottom:40px; 
    background-color:white !important;
  }
}

/* iphone 12, 12 Pro */
@media only screen and (min-width: 390px) and (max-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
  .totalOrder {
    margin-bottom:40px; 
    background-color:white !important;
  }
}

/* iphone XR, 11 */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 2) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
  .totalOrder {
    margin-bottom:40px; 
    background-color:white !important;
  }
}
    
/* iphone XS Max, 11 Pro Max */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
  .totalOrder {
    margin-bottom:40px; 
    background-color:white !important;
  }
}

/* iphone 12 Pro Max */
@media only screen and (min-width : 428px) and (max-height : 926px) and (-webkit-device-pixel-ratio : 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
  .totalOrder {
    margin-bottom:40px; 
    background-color:white !important;
  }
}
</style>